<style>
  .container {
    width: 100% !important;
    position: static !important;
  }

  .invoiceinput {
    border: 1px solid rgb(224, 224, 224);
    border-radius: 4px;
    padding: 5px 10px;
  }

  .bold {
    font-weight: bold;
  }

  .paddingbottom {
    padding-bottom: 15px;
  }

  .margintop {
    margin-top: 25px;
  }

  mat-icon {
    position: relative;
    top: 0;
    margin: 0 5px;
    vertical-align: middle;
  }

  .dialogbutton {
    height: 42px;
    width: 100%;
    cursor: pointer;
  }
  /*
  .material-icons {
    font-size: 16px;
  }*/

  .error-tooltip {
    font-size: 16px;
    padding-top: 3px;
  }

  .error-message {
    color: red;
    font-size: 80%;
    margin-bottom: 15px;
  }

  .warning-box {
    border: 1px solid red;
    background-color: #ffe5e5; /* Light red background */
    padding: 20px;
    margin: 10px auto 20px auto;
    font-weight: bold;
  }

  .editbutton, .editbutton button, .editbutton button .mat-icon {
    float: right;
    cursor: pointer;
    display: inline;
  }

  .customer-action.mat-stroked-button {
    min-width: 28px;
    width: 28px;
    height: 28px;
    padding: 0;
  }

  .customer-action .mat-icon {
    font-size: 28px;
    height: 28px;
    width: 28px;
    line-height: 28px;
  }

  /* Preview button: white background, black text */
  .preview-btn.mat-stroked-button {
    background: #fff;
    color: #000;
    border-color: #E3E3E3;
  }

  .invoice-toggle {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
  }

  .invoice-toggle h4,
  .invoice-toggle mat-card-title {
    flex: 1;
    margin: 0 !important;
    padding: 0;
  }

  .invoice-toggle mat-icon {
    margin-left: auto;
  }

  .invoice-toggle-content {
    padding-bottom: 10px;
  }
</style>

<div *ngIf="invoiceViewReady && invoice && isInvoiceCreated()" class="container invoice-tool-page">
  <div class="row invoice-tool-hero">
    <div class="col-md-12 invoice-tool-hero-content">
      <h3 *ngIf="!invoice.SubInvoice" class="main-heading sam-page-heading">SKAPA EN FAKTURA <span *ngIf="invoice?.CreditInvoiceFor != null" class="credit-invoice-label">Kreditfaktura</span></h3>
      <h3 *ngIf="invoice.SubInvoice" class="main-heading sam-page-heading">UNDERLAG FÖR DIN LÖNEUTBETALNING</h3>
      <p *ngIf="!invoice.SubInvoice">Fyll i delarna nedan i din egen takt. Du kan spara ett utkast och fortsätta senare.</p>
      <p *ngIf="invoice.SubInvoice">Detta är underlaget vi har fått från uppdragsgivaren och som vi baserar din löneutbetalning på.</p>

      <div class="info-box" *ngIf="false && referralCode">
        Vi har automatiskt lagt till din värvningsrabatt på denna faktura, du behöver inte göra något.<br />
        <span class="info-box-strong">Din rabatt: {{ referralDiscountText }}</span>
      </div>

      <div class="warning-box" *ngIf="Suspended">
        <span>Ditt konto är spärrat pga misstänkt missbruk eller brott mot våra villkor.<br /> Kontakta supporten för att låsa upp kontot. Ring 08 - 51 81 64 40.</span>
      </div>

    </div>
  </div>

  <nav class="invoice-tool-steps" *ngIf="!invoice.SubInvoice" aria-label="Fakturans delar">
    <button type="button" class="invoice-tool-step" (click)="scrollToInvoiceSection('invoice-customer-section')"><span>1</span><strong>Kund</strong></button>
    <button type="button" class="invoice-tool-step" (click)="scrollToInvoiceSection('invoice-specification-section')"><span>2</span><strong>Specifikation</strong></button>
    <button type="button" class="invoice-tool-step" (click)="scrollToInvoiceSection('invoice-billing-section')"><span>3</span><strong>Fakturering</strong></button>
    <button type="button" class="invoice-tool-step" (click)="scrollToInvoiceSection('invoice-payout-section')"><span>4</span><strong>Utbetalning</strong></button>
  </nav>

  <div *ngIf="!invoice.SubInvoice && (bankInfoNeedsUpdate || userEmailNeedsUpdate || userPersonalNumberNeedsUpdate || userPhoneNumberNeedsUpdate)" class="row align-items-end section">
    <div class="col-sm-12 col-md-12 col-lg-12 select-customer">

      <!-- PERSONUPPGIFTER -->
      <mat-card class="col-sm-12 personal-details-card">
        <div class="personal-details-header">
          <span class="personal-details-icon" aria-hidden="true"><mat-icon>person_outline</mat-icon></span>
          <div>
            <h2>Komplettera dina personuppgifter</h2>
            <p>Vi behöver uppgifterna för att kunna skicka fakturan och betala ut din lön.</p>
          </div>
        </div>

        <div class="personal-details-form">
            <!--Bankuppgifter saknas-->
            <div *ngIf="bankInfoNeedsUpdate" class="personal-details-grid">
                <mat-form-field floatLabel="always" class="personal-details-wide">
                  <mat-label>Välj svensk/utländsk bank eller personkonto</mat-label>
                  <mat-select [ngModel]="bankEntryMode" name="bankEntryMode" [disabled]="isInvoiceContentLocked() || (!banks?.length || userInfoSaving)"
                              (ngModelChange)="onBankEntryModeChange($event)">
                    <mat-option value="swedish">Svensk bank</mat-option>
                    <mat-option value="personkonto">Nordea personkonto</mat-option>
                    <mat-option value="international">Utländsk bank</mat-option>
                  </mat-select>
                </mat-form-field>
                <div class="personal-details-wide" *ngIf="bankEntryMode !== 'international'" aria-live="polite">
                  <span>Bank: </span><strong>{{ invoiceSender?.BankName || '-' }}</strong>
                </div>

              <ng-container *ngIf="bankEntryMode === 'international'">
                  <mat-form-field floatLabel="always">
                    <mat-label>BIC</mat-label>
                    <input [disabled]="isInvoiceContentLocked()" matInput
                           [ngModel]="invoiceSender?.Bic"
                           (ngModelChange)="invoiceSender.Bic = $event; scheduleBankValidation()"
                          
                           id="bic"
                           name="bic">
                    <mat-error>Ange 8 eller 11 bokstäver och siffror</mat-error>
                    <mat-hint>Ange 8 eller 11 bokstäver och siffror</mat-hint>
                  </mat-form-field>

                  <mat-form-field floatLabel="always">
                    <mat-label>IBAN</mat-label>
                    <input [disabled]="isInvoiceContentLocked()" matInput
                           [ngModel]="invoiceSender.Iban"
                           (ngModelChange)="invoiceSender.Iban = $event; scheduleBankValidation()"
                          
                           id="iban"
                           name="iban">
                    <mat-error>Ange 15–34 bokstäver och siffror</mat-error>
                    <mat-hint>Ange upp till 34 bokstäver och siffror</mat-hint>
                  </mat-form-field>
              </ng-container>

              <ng-container *ngIf="bankEntryMode !== 'international'">
                <mat-form-field floatLabel="always" *ngIf="bankEntryMode === 'swedish'">
                  <mat-label>Clearingnummer</mat-label>
                  <input [disabled]="isInvoiceContentLocked()" matInput [ngModel]="invoiceSender?.ClearingNumber"
                         (ngModelChange)="onClearingNumberChange($event)"
                         id="ClearingNumber" name="ClearingNumber">
                  <mat-hint>{{ getClearingHint() }}</mat-hint>
                </mat-form-field>
                <mat-form-field floatLabel="always">
                  <mat-label>Kontonummer</mat-label>
                  <input [disabled]="isInvoiceContentLocked()" matInput [ngModel]="invoiceSender?.AccountNumber"
                         (ngModelChange)="onAccountNumberChange($event)"
                         (focus)="onAccountNumberFocus()"
                         [readonly]="bankEntryMode === 'personkonto'"
                         id="AccountNumber" name="AccountNumber">
                  <mat-hint>{{ getAccountHint() }}</mat-hint>
                </mat-form-field>
              </ng-container>
              <mat-error class="personal-details-wide" *ngIf="bankValidationMessage" role="status">
                {{ bankValidationMessage }}
              </mat-error>
            </div>
            <!-- / Bankuppgifter saknas-->

            <div class="personal-details-grid personal-details-contact-grid"
                 *ngIf="userPersonalNumberNeedsUpdate || userEmailNeedsUpdate || userPhoneNumberNeedsUpdate">
              <!-- Personnr saknas-->
              <mat-form-field *ngIf="userPersonalNumberNeedsUpdate" floatLabel="always">
                <mat-label>Personnummer / samordningsnummer</mat-label>
                <input [disabled]="isInvoiceContentLocked()" matInput [ngModel]="missingPersonalNumber" (ngModelChange)="onMissingPersonalNumberChange($event)" pattern="[0-9]{12}" maxlength="12" id="PersonalNumber" name="PersonalNumber">
              </mat-form-field>
              <!-- / Personnr saknas-->
              <!-- Email saknas-->
              <mat-form-field *ngIf="userEmailNeedsUpdate" floatLabel="always">
                <mat-label>E-post</mat-label>
                <input [disabled]="isInvoiceContentLocked()" matInput [(ngModel)]="missingEmail" id="email" name="invoice-recipient-email" autocomplete="section-invoice-recipient email">
              </mat-form-field>
              <!-- / Email saknas-->
              <!-- Telefonnr saknas-->
              <mat-form-field *ngIf="userPhoneNumberNeedsUpdate" floatLabel="always">
                <mat-label>Telefon</mat-label>
                <input [disabled]="isInvoiceContentLocked()" matInput [(ngModel)]="missingPhone" id="telephone" name="telephone">
              </mat-form-field>
              <!-- / Telefonnr saknas-->
            </div>

          <div class="personal-details-actions">
            <button mat-flat-button
                    (click)="saveUserContactAndBankInfo()"
                    [disabled]="userInfoSaving || userInfoSaveValid()"
                    color="accent">
              Spara uppgifter
            </button>
          </div>
        </div>
      </mat-card>
      <!-- PERSONUPPGIFTER -->
    </div>
  </div>





    <div class="row align-items-end section">

      <div id="invoice-customer-section" class="col-sm-12 d-flex justify-content-start invoice-section-heading">
        <span class="invoice-section-heading-icon" aria-hidden="true"><mat-icon>person_outline</mat-icon></span>
        <h2>1. {{ invoice.SubInvoice ? 'Uppdragsgivare' : 'Kund' }}</h2>
        <!--<mat-icon class="descriptionIcon" color="accent">assignment_ind</mat-icon>-->
      </div>

      <div *ngIf="!invoice.SubInvoice"
           class="col-sm-12 col-md-8 col-lg-6 select-customer"
           [class.customer-selection-empty]="!invoice?.Customer?.Id">
        <mat-card class="select-customer-card">
          <mat-card-title>Välj en kund<mat-icon color="accent" class="info-icon" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Om mottagaren är privatperson så behöver inte referens finnas med">info</mat-icon></mat-card-title>

          <!-- Select customer -->
          <div class="row">
            <div class="col-9">

              <mat-form-field *ngIf="companiesLoaded" floatLabel="always" class="customer-select-field">
                <mat-label>Ange mottagare</mat-label>
                <mat-select [disabled]="!canUpdateGeneral() || companies.length == 0" name="companies" placeholder="Ange mottagare" [ngModel]="invoice?.Customer?.Id" (ngModelChange)="invoice && invoice.Customer ? (invoice.Customer.Id = $event) : null; customerChange($event); updateTotalInvoiceAmount()">
                  <mat-option [value]="0"></mat-option>
                  <mat-option *ngFor="let c of companies" [value]="c.Id">
                    {{ c.Name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </div>
            <div class="col-3 action-buttons">

              <button mat-stroked-button color="accent" class="customer-action"
                      (click)="addCustomer()"
                      [disabled]="!canUpdateGeneral()"
                      matTooltip="Lägg till ny kund" matTooltipPosition="before">
                <mat-icon>person_add</mat-icon>
              </button>

              <button mat-stroked-button color="accent" class="customer-action"
                      *ngIf="invoice?.Customer.Id > 0"
                      (click)="editCustomer()"
                      [disabled]="!canUpdateGeneral() || invoice?.Customer.Global"
                      matTooltip="Redigera" matTooltipPosition="before">
                <mat-icon class="edit-icon">edit</mat-icon>
              </button>
            </div>
          </div>
          <!-- Select reference person -->
          <div class="row">
            <div class="col-9">
              <mat-form-field floatLabel="always" *ngIf="invoice.Customer.IsCompany && contactsLoaded" class="customer-select-field">
                <mat-label>Din kontaktperson*</mat-label>
                <mat-select [disabled]="!canUpdateGeneral() || contacts == null || contacts.length == 0" placeholder="Din kontaktperson*" [ngModel]="invoice?.Reference?.Id" (ngModelChange)="contactChange($event)">
                  <mat-option *ngFor="let c of contacts" [value]="c.Id">
                    {{ c.Name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-3 action-buttons">
              <button mat-stroked-button color="accent" class="customer-action"
                      *ngIf="invoice?.Customer.Id > 0"
                      (click)="addContact()"
                      [disabled]="!canUpdateGeneral()"
                      [hidden]="!invoice.Customer.IsCompany"
                      matTooltip="Lägg till ny kontakt" matTooltipPosition="before">
                <mat-icon>person_add</mat-icon>
              </button>
              <button mat-stroked-button color="accent" class="customer-action"
                      *ngIf="invoice?.Reference.Id > 0"
                      (click)="editContact(invoice.Reference)"
                      [disabled]="!canUpdateGeneral()"
                      matTooltip="Redigera" matTooltipPosition="before">
                <mat-icon class="edit-icon">edit</mat-icon>
              </button>
            </div>
          </div>

        </mat-card>
      </div>

      <div *ngIf="!invoice?.Customer?.Id" class="customer-info-placeholder" [ngClass]="invoice.SubInvoice ? 'col-12' : 'col-sm-12 col-md-8 col-lg-6'">
        <mat-card class="customer-info-card" style="height: 250px; width: 100%;"></mat-card>
      </div>

      <!-- Fryst kundkort-->
      <div *ngIf="invoice?.Customer?.Id > 0 && invoice?.CustomerCopy?.Name != null" [ngClass]="invoice.SubInvoice ? 'col-12' : 'col-sm-12 col-md-8 col-lg-6'">
        <mat-card class="customer-info-card" style="height: 250px; width: 100%;">
          <div>
            <h3>{{invoice?.CustomerCopy?.Name}}
            <!--<mat-icon color="accent" style="top: 5px; height: 20px; width: 20px; font-size: 30px;">person</mat-icon>-->
            <mat-icon *ngIf="isAdmin" style="color: green; top: 5px; height: 30px; width: 30px; float: right;" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Denna kundinfo är låst till fakturan">verified</mat-icon><br /><br /></h3>
            <div *ngIf="invoice.CustomerCopy.Co != null && invoice.CustomerCopy.Co != ''">
              C/o: {{invoice.CustomerCopy.Co}}<br />
              {{invoice.CustomerCopy.Reference}}
            </div>
            {{invoice?.CustomerCopy?.Address}}<br />
            {{invoice?.CustomerCopy?.Zip}} {{invoice?.CustomerCopy?.City}}<br />
            {{invoice?.CustomerCopy?.Country?.Name}}<br /><br />
            <span *ngIf="invoice?.Customer?.OrgNumber != ''">{{invoice?.CustomerCopy?.OrgNumber}}</span>
            <span *ngIf="invoice?.Customer?.PersonalNumber != ''">{{invoice?.CustomerCopy?.PersonalNumber}}</span>
          </div>
        </mat-card>
      </div>
      <!-- /Fryst kundkort-->
      <!--Redigerbart kundkort-->
      <div *ngIf="invoice?.Customer.Id > 0 && invoice?.CustomerCopy?.Name == null" [ngClass]="invoice.SubInvoice ? 'col-12' : 'col-sm-12 col-md-8 col-lg-6'">
        <mat-card class="customer-info-card" style="height: 250px; width: 100%;">
          <div>
            <h3>{{invoice?.Customer?.Name}}
            <!--<mat-icon color="accent" style="top: 5px; height: 20px; width: 20px; font-size: 30px;">person</mat-icon>-->
            <mat-icon *ngIf="isAdmin" style="color: grey; top: 5px; height: 30px; width: 30px; float: right;" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Denna kundinfo är inte låst till fakturan">verified</mat-icon><br /><br /></h3>
            <div *ngIf="invoice.Customer.Co != null && invoice.Customer.Co != ''">
              c/o: {{invoice.Customer.Co}}<br />
              {{invoice.Customer.Reference}}
            </div>
            {{invoice?.Customer?.Address}}<br />
            {{invoice?.Customer?.Zip}} {{invoice?.Customer?.City}}<br />
            {{invoice?.Customer?.Country?.Name}}<br /><br />
            <span *ngIf="invoice?.Customer?.OrgNumber != ''">{{invoice?.Customer?.OrgNumber}}</span>
            <span *ngIf="invoice?.Customer?.PersonalNumber != ''">{{invoice?.Customer?.PersonalNumber}}</span>
          </div>
        </mat-card>
      </div>
      <!-- / Redigerbart kundkort-->

      <div class="col-sm-12 col-md-12">
        <p *ngIf="invoice?.Customer.Id > 0 && !invoice.Customer.Active && !invoice.SubInvoice" style="color: red;">Detta organisationsnummer används inte längre. Kontakta din kund eller SAMpoolen vid frågor.</p>
        <p *ngIf="invoice?.Customer?.PublicInfo" class="warning-box">{{ invoice?.Customer?.PublicInfo }}</p>
        <p style="color: red;" *ngIf="isAdmin">{{ invoice?.Customer?.AdminInfo }}</p>
      </div>

      <div id="invoice-specification-section" class="col-sm-12 d-flex justify-content-start invoice-section-heading">
        <span class="invoice-section-heading-icon" aria-hidden="true"><mat-icon>description</mat-icon></span>
        <h2>2. Specifikation</h2>
        <!--<mat-icon class="descriptionIcon" color="accent">assignment</mat-icon>-->
      </div>

      <div class="col-sm-12 col-md-12">
        <mat-card>
          <mat-card-title *ngIf="!invoice.SubInvoice">Vad ska faktureras?</mat-card-title>
          <mat-card-title *ngIf="invoice.SubInvoice">Fakturerat</mat-card-title>
          <div class="row">
            <div *ngIf="invoice.SubInvoice && !IsCommissionInvoice" class="col-lg-12 paddingbottom">
              Detta är vad din kund/arbetsgivare kommer att betala för dig, inklusive skatt och sociala avgifter. Kontrollera din Ekonomi-sida för att se vad du får betalt efter sociala avgifter och kommunalskatt. Om du vill kunna begära <i>arbetsgivarintyg</i> måste du lägga till timmar och datum.
            </div>
            <div *ngIf="!invoice.SubInvoice" class="col-lg-12 paddingbottom">
              Ange vad du vill lägga till din faktura.
            </div>
          </div>
          <div *ngIf="!invoice.SubInvoice" class="row margintop">
            <div class="col-sm-12 col-md-12">
              <mat-form-field floatLabel="always" appearance="outline" style="width:100%;">
                <mat-label>Beskrivning av utfört arbete (obligatorisk). Addera fler fakturaobjekt genom att klicka på "Spara till fakturan" igen.</mat-label>
                <textarea matInput
                          rows="3"
                          [disabled]="!canUpdateGeneral()"
                          [(ngModel)]="invoiceQuickGroup.Description"
                          (ngModelChange)="quickRowValidate();wordCountDescription();"
                          placeholder="Beskrivning av utfört arbete"
                          id="message" name="description-quick-add"></textarea>
                <!--<mat-hint>{{resultDescription}}</mat-hint>-->
              </mat-form-field>
              <div class="col-lg-12">
                <span class="error-message">{{ErrorMessageDesc}}</span>
              </div>
            </div>
          </div>
          <div *ngIf="!invoice.SubInvoice" class="row margintop invoice-quick-entry-row">
            <div class="col-sm-12 col-md-3 quick-add invoice-amount-control">
              <h5>Belopp (ex moms) *</h5>
              <input matInput [disabled]="!canUpdateGeneral() || !invoice?.Customer.Id" class="text-input amount" name="name" id="name" #name="ngModel" type="number" pattern="^-?[0-9]+(\.[0-9]{1,2})?$" [(ngModel)]="invoiceQuickGroup.Amount" ngDefaultControl [ngModelOptions]="{standalone: true}">

              <div *ngIf="name.invalid">
                <span style="color: red; font-size: 80%;">Inmatningen får bara innehålla heltal, kommatecken och max två decimaler.</span>
              </div>

              <div *ngIf="!invoice?.Customer.Id" class="select-vat">
                <mat-hint>Välj kund under punkt 1 för att kunna lägga till belopp</mat-hint>
              </div>
            </div>
            <div class="col-sm-6 col-md-3 quick-add invoice-vat-column">
              <div class="invoice-vat-control">
              <div class="d-flex justify-content-between">
                <h5>Moms *</h5>
                <span class="vat-information-link">0 % moms? <button type="button" class="accent" (click)="openVatInformationDialog()">Klicka här</button></span>
              </div>
              <mat-form-field floatLabel="always" class="invoice-select-field">
                <!--<mat-label>Momssats</mat-label>-->
                <mat-select [disabled]="!invoice?.Customer?.Id || isInvoiceContentLocked() || invoiceQuickGroup.ReverseTax" class="select-vat" [(ngModel)]="quickGroupVat" name="rowvatselected">
                  <mat-option *ngFor="let item of vatList" [value]="item.Value">{{item.Value}} %</mat-option>
                </mat-select>
              </mat-form-field>
              <div *ngIf="!invoice?.Customer.Id" class="select-vat">
                <mat-hint>Välj kund under punkt 1 för att visa momsalternativ</mat-hint>
              </div>
              </div>
              <mat-checkbox [disabled]="!canUpdateGeneral()"
                            [hidden]="!invoice.Customer.IsCompany || invoice.Customer.Country?.Id > 1"
                            [checked]="reverseTaxTemp"
                            (change)="onReverseTaxChange($event)">
                Byggmoms
              </mat-checkbox>
            </div>
            <div class="col-sm-6 col-md-3 invoice-date-control" *ngIf="usesLegacyInvoiceGroupMode()">
              <button mat-flat-button color="primary" [disabled]="invoiceGroupSaving || !saveQuickRowValidates() || !canUpdateGeneral()" (click)="saveQuickRow(invoiceQuickGroup,true)" style="margin-top:27px;height:42px;width:100%;">
                Uppge datum/tid &nbsp;&nbsp;<i class="fa fa-plus fa-lg"></i>
              </button>
            </div>
            <div class="col-sm-12 invoice-save-control" [class.col-md-6]="!usesLegacyInvoiceGroupMode()" [class.col-md-3]="usesLegacyInvoiceGroupMode()">
              <button mat-flat-button color="accent" [disabled]="isInvoiceContentLocked() || (invoiceGroupSaving || !saveQuickRowValidates() || !quickrowValid || (usesLegacyInvoiceGroupMode() && !timeReportValidates()))" (click)="saveQuickRow(invoiceQuickGroup,false); updateTotalInvoiceAmount(); updatePensionSavingsAmount()" style="margin-top:27px;height:42px;float:right;width:100%;max-width:320px;">{{ invoiceGroupSaving ? 'Sparar...' : 'Spara till fakturan' }}</button>
              <div class="error-message" style="color: black;">{{errorMessageSaveQuickRow}}</div>
            </div>
          </div>



          <div class="row time-group" [hidden]="getDisplayedInvoiceGroups().length == 0" *ngFor="let group of getDisplayedInvoiceGroups()">

            <span style="width:100%;"><b>{{ isWorkedHoursGroup(group) ? 'Arbetad tid' : 'Fakturerat' }}</b><mat-icon *ngIf="!isInvoiceContentLocked() && (!invoiceGroupSaving && !IsCommissionInvoice && !invoice.CreditInvoiceFor > 0 && (!isWorkedHoursGroup(group) || canEditWorkedHoursGroup()))" class="editbutton" (click)="editInvoiceCalendar(group)">edit</mat-icon></span>

            <span
              class="angular-with-newlines description"
              style="width:100%;margin-bottom:0px;"
              *ngIf="group.Description && !isWorkedHoursGroup(group)"
            >
              <i>{{group.Description}}</i>
            </span>

            <span *ngIf="group.TimeReportStatus && !isInvoiceItemGroup(group)" class="angular-with-newlines description" style="margin-bottom:12px;">
              Visa på faktura: {{group.TimeReportStatus?.DisplayName}}
            </span><br />

            <span *ngIf="isWorkedHoursGroup(group) && group.WorkingTitle" class="angular-with-newlines description" style="margin-bottom:12px;">
              Befattning: {{group.WorkingTitle}}
            </span><br />

            <span *ngIf="isWorkedHoursGroup(group) && (group.WorkCountry || invoice?.WorkCountry)" class="angular-with-newlines description" style="margin-bottom:12px;">
              Arbetat land: {{group.WorkCountry || invoice?.WorkCountry}}
            </span>

            <div class="row time-row" *ngFor="let i of group.InvoiceRows; let idx = index" style="width: 100%;" [hidden]="!usesLegacyInvoiceGroupMode() && !isWorkedHoursGroup(group)">
              <div class="col">

                <span *ngIf="i.StartDate">
                  {{i.StartDate | swedishDate: 'yyyy-MM-dd'}}
                </span>
                <span *ngIf="i.HoursWorked || (invoice.SubInvoice && i.MinutesWorked > 0)">({{i.HoursWorked || 0}} h{{i.MinutesWorked > 0 ? ' ' + i.MinutesWorked + ' min' : ''}})</span>
                <i *ngIf="isPreNotifiedInvoiceRow(i, group)"> f&ouml;ranm&auml;ld</i>
                <!--<span *ngIf="group.Type.Value != 4">({{i.Vat}} % moms)</span>-->


              </div>
            </div>
            <div style="display: block; width: 100%;" *ngIf="group.ReverseTax">
              Omvänd skattskyldighet/byggmoms
            </div>
            <div class="col" style="padding-left: 0px;" *ngIf="group?.Amount != null && !isWorkedHoursGroup(group)">
              <!--<span *ngIf="(invoice.Customer.Country?.Name != 'Sverige') && (invoice.RecieverCountry != 'Sverige') && !isAdmin" class="row-total-amount">Belopp: {{group?.Amount | number }} {{invoice?.Currency?.Name}} (exkl. 0 % moms)</span>
            <span *ngIf="(invoice.Customer.Country?.Name == 'Sverige') || (invoice.RecieverCountry == 'Sverige') || isAdmin" class="row-total-amount">Belopp: {{group?.Amount | number }} {{invoice?.Currency?.Name}} (exkl. {{group?.Vat}} % moms)</span>-->
              <span class="row-total-amount">Belopp: {{group?.Amount | number : (group.Amount % 1 === 0 ? '1.0-0' : '1.2-2')}} {{invoice?.Currency?.Name}} (exkl. {{group?.Vat}} % moms)</span>
            </div>
          </div>

          <div class="worked-hours-group">
          <div id="worked-hours-section" *ngIf="!usesLegacyInvoiceGroupMode()">
            <h4>Arbetad tid</h4>
            <mat-icon *ngIf="!isInvoiceContentLocked() && (!invoiceGroupSaving && !IsCommissionInvoice && !invoice.CreditInvoiceFor > 0 && getWorkedHoursInvoiceGroup() && canEditWorkedHoursGroup())" class="editbutton" style="margin-left:auto;" (click)="editInvoiceCalendar(getWorkedHoursInvoiceGroup())">edit</mat-icon>
          </div>

          <div *ngIf="!hasReportedWorkDate()" class="row worked-hours-empty-row">
            <div class="col-sm-12 col-md-6 paddingbottom">
              <div>
                För att kunna begära arbetsgivarintyg, anställningsbevis och för att vi ska kunna rapportera hur du mycket jobbat vid förfrågan från t ex Försäkringskassan vid sjukdom eller föräldraledighet måste du ange vilka dagar och antal timmar du arbetat.
              </div>
            </div>
            <div class="col-sm-12 col-md-6 d-flex justify-content-md-end justify-content-start align-items-start worked-hours-action">
              <div class="worked-hours-controls">
                <button mat-flat-button color="accent" class="worked-hours-button" [disabled]="invoiceGroupSaving || !canEditWorkedHoursGroup()" (click)="createOrEditWorkedHoursGroup()" style="height:42px;min-width:320px;">
                  {{ invoiceGroupSaving ? 'Sparar...' : 'Uppge arbetad tid' }}
                </button>
                <mat-checkbox *ngIf="!invoice?.SubInvoice" [(ngModel)]="skipTimeReporting" (change)="sendValidates()">
                  Jag väljer att avstå tidrapportering
                </mat-checkbox>
              </div>
            </div>
          </div>

          <div *ngIf="!usesLegacyInvoiceGroupMode() && getWorkedHoursInvoiceGroup() as workedHoursGroup" class="row worked-hours-details" style="margin-top: 0; padding: 0 15px 0 15px;">
            <span *ngIf="workedHoursGroup.TimeReportStatus" class="angular-with-newlines description" style="display:block;width:100%;margin-bottom:12px;">Visa p&aring; faktura: {{workedHoursGroup.TimeReportStatus?.DisplayName}}</span>

            <span *ngIf="workedHoursGroup.WorkingTitle" class="angular-with-newlines description" style="display:block;width:100%;margin-bottom:12px;">
              Befattning: {{workedHoursGroup.WorkingTitle}}
            </span>

            <span *ngIf="workedHoursGroup.WorkCountry || invoice?.WorkCountry" class="angular-with-newlines description" style="margin-bottom:12px;">
              Arbetat land: {{workedHoursGroup.WorkCountry || invoice?.WorkCountry}}
            </span>

            <div class="row time-row" *ngFor="let i of workedHoursGroup.InvoiceRows; let idx = index" style="width: 100%;">
              <div class="col">
                <span *ngIf="i.StartDate">
                  {{i.StartDate | swedishDate: 'yyyy-MM-dd'}}
                </span>
                <span *ngIf="i.HoursWorked || (invoice.SubInvoice && i.MinutesWorked > 0)">({{i.HoursWorked || 0}} h{{i.MinutesWorked > 0 ? ' ' + i.MinutesWorked + ' min' : ''}})</span>
                <i *ngIf="isPreNotifiedInvoiceRow(i, workedHoursGroup)"> f&ouml;ranm&auml;ld</i>
              </div>
            </div>
          </div>
          </div>

          <div class="invoice-support-group" *ngIf="!invoice?.SubInvoice">
          <div class="margintop invoice-inline-toggle-card invoice-expense-toggle-card" *ngIf="!invoice?.SubInvoice">
            <button type="button" class="invoice-toggle margintop" (click)="invoiceExpenseToggleOpen = !invoiceExpenseToggleOpen">
              <h4>Fakturera för dina utlägg och resekostnader</h4>
              <mat-icon>{{ invoiceExpenseToggleOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>

            <div *ngIf="invoiceExpenseToggleOpen" class="invoice-toggle-content">
              <div *ngIf="!invoice?.Customer.Id" class="select-vat">
                <mat-hint>Du måste välja en kund för att kunna lägga till utlägg och resekostnader till din faktura</mat-hint>
              </div>
              <div *ngIf="invoice.Customer.Country?.Id == 1 && invoice.Currency.Name == 'SEK'">
                <div class="row buttonrow paddingbottom invoice-expense-content">
                  <div class="col-lg-6 select-vat">
                    Om du vill att kunden ska betala dina utlägg och resekostnader lägger du till dem här. Du kan bara lägga till dem till fakturan innan du skickar den. Om du enbart önskar addera dem som avdrag, gör det under punkt 4. Detta kan du göra ända tills vi betalar ut din lön.
                  </div>
                  <div class="col-sm-6 col-md-3" *ngIf="invoice.Status.TechnicalName != 'UnderReview' || invoice.Status.Id != null || invoice.Status.TechnicalName != 'Draft'">
                    <button mat-flat-button color="accent" class="expense-add-button" [disabled]="!canUpdateGeneral()" (click)="editDeduction('addedToInvoice')" style="height:42px;width:100%; cursor:pointer;">
                      <mat-icon>add</mat-icon> Kostnader / utlägg / reseutlägg
                    </button>
                  </div>
                  <div class="col-sm-6 col-md-3" *ngIf="invoice.Status.TechnicalName != 'UnderReview' || invoice.Status.Id != null || invoice.Status.TechnicalName != 'Draft'">
                    <button mat-flat-button color="accent" class="expense-add-button" [disabled]="!canUpdateGeneral()" (click)="editAllowance('addedToInvoice')" style="height:42px;width:100%; cursor: pointer;">
                      <mat-icon>add</mat-icon> Milersättning / traktamente
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-lg-8" *ngIf="invoice.Currency.Name != 'SEK'">
                När du fakturerar din kund i annan faktura än SEK behöver du själv räkna ut hur mycket dina utlägg är värda i valutan du valt, och lägga till dem som vanliga fakturaobjekt ovan. För att få dem tillbaka skattefritt på din löneutbetalning lägger du även till dem nedan under punkt 4.
              </div>
              <div class="col-lg-12 invoice-warning-row" *ngIf="showForeignCurrencyBillableExpensesWarning()">
                <span class="invoice-warning-message">{{getForeignCurrencyBillableExpensesErrorMessage()}}</span>
              </div>

              <!--Deductions added as invoice item-->
              <div [hidden]="!canUpdatePayout()">
                <div *ngFor="let c of invoice.Deductions">
                  <div *ngIf="c.AddedToInvoice == true" class="time-group">
                <div class="invoice-deduction-body">
                  <div class="invoice-deduction-header">
                    <strong>Kostnader / utlägg</strong>
                    <div class="invoice-deduction-actions">
                      <button mat-icon-button [disabled]="!canUpdateGeneral() || (c.AddedToInvoice && invoice.SubInvoice)" aria-label="Radera utlägg" matTooltip="Radera utlägg" (click)="deleteDeduction(c)"><mat-icon>delete</mat-icon></button>
                      <button mat-icon-button [disabled]="!canUpdateGeneral() || (c.AddedToInvoice && invoice.SubInvoice)" aria-label="Redigera utlägg" matTooltip="Redigera utlägg" (click)="editDeduction('', c)"><mat-icon class="edit-icon">edit</mat-icon></button>
                    </div>
                  </div>
                  <div class="invoice-deduction-billing-state"><i>Faktureras kund</i></div>
                  <div class="invoice-deduction-details">
                    <div>
                      <div class="invoice-deduction-name">{{c.Name}} <i>(denna rad visas på fakturan)</i></div>
                      <div *ngIf="c.AgreedInvoiceAmount != null && c.AgreedInvoiceAmount !== c.Amount">Skattefritt utlägg: {{c.Amount}} SEK</div>
                      <span class="error-message" *ngIf="!c.Attachment?.Guid">Det saknas kvitto till detta utlägg</span>
                    </div>
                    <div class="invoice-deduction-customer">Faktureras kund: {{c.AgreedInvoiceAmount != null ? c.AgreedInvoiceAmount : c.Amount}} SEK</div>
                  </div>
                </div>
                <div class="deduction-document-actions" *ngIf="c.Attachment?.Guid || c.Attachment?.Url || c.AttachmentReciept?.Guid || c.AttachmentReciept?.Url">
                  <button type="button" mat-stroked-button *ngIf="c.Attachment?.Guid || c.Attachment?.Url" (click)="showFile(c.Attachment)">Visa kvitto</button>
                  <button type="button" mat-stroked-button *ngIf="c.AttachmentReciept?.Guid || c.AttachmentReciept?.Url" (click)="showFile(c.AttachmentReciept)">Visa betalningskvittens</button>
                </div>
                <div class="col-lg-12 warning-box" *ngIf="c.DeniedReason && c.DeniedReason.trim().length > 0">
                  <span>{{c.DeniedReason}}</span>
                </div>
                  </div>
                </div>
              </div>

              <!--Allowances added as invoice item-->
              <div [hidden]="!canUpdatePayout()">
                <div *ngFor="let c of invoice.Allowances">
                  <div *ngIf="c.AddedToInvoice == true" class="time-group invoice-allowance-item">
                    <div class="invoice-allowance-body">
                      <div class="invoice-allowance-header">
                        <strong>{{getAllowanceTypeName(c?.AllowanceType?.Id)}}</strong>
                        <div class="invoice-allowance-actions">
                          <button *ngIf="c?.AllowanceType?.Id == 1 || c?.AllowanceType?.Id == '1'" mat-icon-button [disabled]="!canUpdateGeneral() || (c.AddedToInvoice && invoice.SubInvoice)" aria-label="Kopiera milersättning" matTooltip="Kopiera milersättning" (click)="copyMileageAllowance(' ', c)"><mat-icon>content_copy</mat-icon></button>
                          <button mat-icon-button [disabled]="!canUpdateGeneral() || (c.AddedToInvoice && invoice.SubInvoice)" aria-label="Radera traktamente eller milersättning" matTooltip="Radera traktamente eller milersättning" (click)="deleteAllowance(c)"><mat-icon>delete</mat-icon></button>
                          <button mat-icon-button [disabled]="!canUpdateGeneral() || (c.AddedToInvoice && invoice.SubInvoice)" aria-label="Redigera traktamente eller milersättning" matTooltip="Redigera traktamente eller milersättning" (click)="editAllowance(' ', c)"><mat-icon class="edit-icon">edit</mat-icon></button>
                        </div>
                      </div>
                      <div class="invoice-allowance-billing-state"><i>Faktureras kund</i></div>
                      <div class="invoice-allowance-details">
                        <div>
                          <div class="invoice-allowance-travel">{{c.TravelDateStart | swedishDate: 'yyyy-MM-dd'}}{{c.TravelDateEnd != null ? ' – ' + (c.TravelDateEnd | swedishDate: 'yyyy-MM-dd') : ''}}{{c.CarRegistrationNumber != null ? ' · ' + c.CarRegistrationNumber : ''}}</div>
                          <div>Skattefri reseersättning: {{c.Sum | number : '1.2-2'}} SEK</div>
                        </div>
                        <div class="invoice-allowance-customer">Faktureras kund: {{(c.CustomReimbursementPerKm !== 0 && c.sumCustomReimbursementPerKm ? c.sumCustomReimbursementPerKm : c.Sum) | number : '1.2-2'}} SEK</div>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>


          <!-- Fakturabilagor -->
          <div class="margintop invoice-inline-toggle-card invoice-attachments" *ngIf="!invoice?.SubInvoice">
            <button type="button" class="invoice-toggle margintop" [attr.aria-expanded]="invoiceAttachmentsToggleOpen" aria-controls="invoice-attachments-content" (click)="invoiceAttachmentsToggleOpen = !invoiceAttachmentsToggleOpen">
              <h4>Fakturabilagor</h4>
              <mat-icon>{{ invoiceAttachmentsToggleOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
            <div *ngIf="invoiceAttachmentsToggleOpen" id="invoice-attachments-content" class="invoice-toggle-content invoice-attachments-content">
              <div class="invoice-attachments-help">
                <p>Ladda upp pdf-dokument som ska bifogas din faktura.</p>
                <p>Kvitton för utlägg laddar du upp ovanför om kunden ska faktureras, annars längre ner i punkt 4.</p>
              </div>
              <div class="invoice-attachments-upload">
                <label for="invoice-attachment-upload">Bifoga pdf</label>
                <input id="invoice-attachment-upload" class="invoice-attachment-file-input" [disabled]="isLoading || !canUpdateGeneral() || invoice.InvoiceSendType == 3" type="file" mat-stroked-button mat-flat-button (change)="uploadDocument($event,invoice.Documents)" accept=".pdf" aria-describedby="invoice-attachments-limits">
              </div>
              <div class="invoice-attachments-list">
                <ng-container *ngFor="let doc of invoice.Documents">
                  <div *ngIf="doc?.FileType?.TechnicalName == 'AttachedInvoiceDocument'" class="invoice-attachment-row">
                    <button type="button" class="invoice-attachment-open" (click)="showFile(doc)" [attr.aria-label]="'Öppna ' + doc.Name">
                      <mat-icon aria-hidden="true">picture_as_pdf</mat-icon>
                      <span class="invoice-attachment-details">
                        <span class="invoice-attachment-name">{{doc?.Name}}</span>
                        <span class="invoice-attachment-size">{{doc?.FileSize / 1048576 | number : '1.2-2'}} Mb</span>
                      </span>
                    </button>
                    <button type="button" class="invoice-attachment-delete" mat-icon-button color="primary" [disabled]="isLoading || !canUpdateGeneral()" (click)="deleteDocumentFromList(doc,invoice.Documents)" [attr.aria-label]="'Radera ' + doc.Name" matTooltip="Radera bilaga"><mat-icon>delete</mat-icon></button>
                  </div>
                </ng-container>
              </div>
              <p *ngIf="errorMessageFiles" class="invoice-attachments-error" role="alert">{{errorMessageFiles}}</p>
              <div *ngIf="totalFileSize != 0" class="invoice-attachments-summary">
                <span>Antal dokument: {{ attachedFilesCount }} st.</span>
                <span>Total filstorlek: {{totalFileSize / 1048576 | number : '1.2-2'}} Mb.</span>
              </div>
              <p id="invoice-attachments-limits" class="invoice-attachments-limits">Högst 5 Mb och 25 sidor per pdf. Du kan ladda upp max 5 filer, totalt 15 Mb.</p>
            </div>
          </div>
          <!-- / fakturabilagor -->
          </div>

          <div *ngIf="invoice.Customer.Country?.Name == 'Sverige' && this.invoice.Customer.IsCompany == false" class="row" style="border-top: 1px solid black; margin: 20px 0 0 0; padding-top: 20px;">
            <div class="col-lg-12">
              <h4>Vill du anmäla RUT eller ROT? </h4>
            </div>

            <!--ROT-->
            <div style="margin-bottom: 17px;" class="col-sm-12 col-md-12 col-lg-12">
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-lg-4">
                  <span class="bold">ROT <mat-icon color="accent" class="info-icon" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Avdraget är max 50 % för ROT">info</mat-icon></span>
                </div>
                <div class="col-lg-8">
                  <mat-checkbox [disabled]="!canUpdateGeneral() || invoice.IsRut" [ngModel]="!invoice.IsRot" (ngModelChange)="invoice.IsRot = $event" (change)="invoice.IsRot = !$event.checked; onRotRutChange()">Nej</mat-checkbox>
                  <mat-checkbox [disabled]="!canUpdateGeneral() || invoice.IsRut" [(ngModel)]="invoice.IsRot" (change)="invoice.IsRot = $event.checked; onRotRutChange()" style="margin-left:15px;">Ja</mat-checkbox> &nbsp;
                </div>
              </div>
              <div *ngIf="invoice.IsRot" class="tax-deduction-fields">
                <mat-form-field floatLabel="always">
                  <mat-label>Framkörningssträcka (km)</mat-label>
                  <input matInput [disabled]="!canUpdateGeneral()" type="number" [(ngModel)]="invoice.RotDrivingFeeKm" (change)="invoice.RotDrivingFeeTotalAmount = (invoice.RotDrivingFeeKm * 3); updateTotalInvoiceAmount()" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
                <mat-form-field floatLabel="always">
                  <mat-label>Framkörningsavgift (SEK)</mat-label>
                  <input matInput disabled type="number" [(ngModel)]="invoice.RotDrivingFeeTotalAmount">
                  <mat-hint>Belopp som faktureras kunden</mat-hint>
                </mat-form-field>
                <mat-form-field floatLabel="always">
                  <mat-label>Fastighetsbeteckning / lägenhetsnr *</mat-label>
                  <input matInput [disabled]="!canUpdateGeneral()" type="text" [(ngModel)]="invoice.RotProperty">
                  <mat-hint>Obligatorisk vid ROT-avdrag</mat-hint>
                </mat-form-field>
                <mat-form-field floatLabel="always">
                  <mat-label>BRF organisationsnummer</mat-label>
                  <input matInput [disabled]="!canUpdateGeneral()" type="text" [(ngModel)]="invoice.BrfOrgNumber">
                  <mat-hint>Ange vid arbete i en BRF</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <!--RUT-->
            <div style="margin-bottom: 17px;" class="col-sm-12 col-md-12 col-lg-12">
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-lg-4">
                  <span class="bold">RUT <mat-icon color="accent" class="info-icon" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Avdraget är max 50% för RUT.">info</mat-icon></span>
                </div>
                <div class="col-lg-8">
                  <mat-checkbox [disabled]="!canUpdateGeneral() || invoice.IsRot" [ngModel]="!invoice.IsRut" (ngModelChange)="invoice.IsRut = $event" (change)="invoice.IsRut = !$event.checked; onRotRutChange()">Nej</mat-checkbox>
                  <mat-checkbox [disabled]="!canUpdateGeneral() || invoice.IsRot" [(ngModel)]="invoice.IsRut" (change)="invoice.IsRut = $event.checked; onRotRutChange()" style="margin-left:15px;">Ja</mat-checkbox> &nbsp;
                </div>
              </div>
              <div *ngIf="invoice.IsRut" class="tax-deduction-fields">
                <mat-form-field floatLabel="always">
                  <mat-label>Framkörningssträcka (km)</mat-label>
                  <input matInput [disabled]="!canUpdateGeneral()" type="number" [(ngModel)]="invoice.RotDrivingFeeKm" (change)="invoice.RotDrivingFeeTotalAmount = (invoice.RotDrivingFeeKm * 3); updateTotalInvoiceAmount()" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
                <mat-form-field floatLabel="always">
                  <mat-label>Framkörningsavgift (SEK)</mat-label>
                  <input matInput disabled type="number" [(ngModel)]="invoice.RotDrivingFeeTotalAmount">
                  <mat-hint>Belopp som faktureras kunden</mat-hint>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row paddingbottom invoice-total-section" style="border-top: 1px solid black; margin: 20px 0">
            <div class="col">
              <span></span>
              <div class="totals">
                <span *ngIf="hoursWorkedTotal > 0" class="total-hours">Totalt antal timmar: {{hoursWorkedTotal | number: '1.0-2'}}</span>
                <div class="total-row">
                  <mat-form-field floatLabel="always" class="currency-select">
                    <mat-label>Valuta</mat-label>
                    <mat-select [disabled]="isInvoiceContentLocked()" [(ngModel)]="invoice.Currency.Id" name="selectcurrency" (selectionChange)="currencyChanged()">
                      <mat-option *ngFor="let item of currencies" value="{{item.Id}}">{{item.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span class="accent">Totalt:</span>
                  <span class="total-amount">{{invoice?.TotalInvoiceAmount | number}} {{invoice?.Currency?.Name}}</span>
                  <span class="total-tax-label">(ex moms)</span>
                </div>
                <span class="invoice-warning-message" *ngIf="showForeignCurrencyBillableExpensesWarning()">{{getForeignCurrencyBillableExpensesErrorMessage()}}</span>
              </div>
            </div>
          </div>

        </mat-card>
      </div>

      <div id="invoice-billing-section" *ngIf="!invoice.SubInvoice" class="col-sm-12 d-flex justify-content-start invoice-section-heading">
        <span class="invoice-section-heading-icon" aria-hidden="true"><mat-icon>receipt_long</mat-icon></span>
        <h2>3. Fakturering</h2>
        <!--<mat-icon class="descriptionIcon" color="accent">description</mat-icon>-->
      </div>

      <div class="col-sm-12">
        <mat-card>
          <div>
            <mat-card-title *ngIf="!invoice.SubInvoice" class="mat-card-title" style="margin: 0 0 20px 0;">Hur vill du skicka fakturan? </mat-card-title>


            <div *ngIf="!invoice?.SubInvoice">
              <div class="row">
                <div style="margin-bottom: 17px;" class="col-sm-12 col-md-12 col-lg-12">
                  <div class="row" style="margin-bottom: 10px;">
                    <div class="col-lg-4">
                      <span class="bold">Fakturamärkning </span> <mat-icon color="accent" class="info-icon" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Här skriver du en kort märkning av fakturan som kommer skrivas på själva fakturan. Detta kan vara ett ordernummer (s.k. PO-nummer), en kod som din kund önskar ha med på fakturan eller en egen märkning som t.ex. vilken månad fakturan gäller.">info</mat-icon>
                    </div>
                    <div class="col-lg-8">
                      <div class="invoice-marking-field">
                        <textarea class="invoiceinput" id="count" #myCounter='ngModel' rows="2"
                                  maxlength="75" [disabled]="!canUpdateGeneral()" matInput *ngIf="invoice"
                                  [(ngModel)]="invoice.Marking" (ngModelChange)="wordCountMarking()" placeholder="Fakturamärkning"></textarea>
                        <mat-hint>{{resultMarking}} | 75 tecken</mat-hint>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div style="margin-bottom: 17px;" class="col-sm-12 col-md-12 col-lg-12">
                  <div class="row payment-term-row" style="margin-bottom: -20px;">
                    <div class="col-lg-4">
                      <span class="bold payment-term-label" style="position: relative; top: 18px;">Betalvillkor:</span>
                    </div>
                    <div class="col-lg-8">
                      <mat-form-field floatLabel="always" class="payment-term-field">
                        <mat-select [disabled]="!canUpdateGeneral() || invoice.Customer.PaymentTermLocked" [ngModel]="invoice.PaymentTerm" (ngModelChange)="invoice.PaymentTerm = $event; getDueDate(); sendValidates();" name="paymentterm">
                          <mat-option *ngFor="let item of paymentTerms" value="{{item}}">{{item}} dagar</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <p *ngIf="canUpdateGeneral()">Beräknat förfallodatum: {{DueDate | swedishDate : 'yyyy-MM-dd'}}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div style="margin-bottom: 17px;" class="col-sm-12 col-md-12 col-lg-12">
                  <div class="row" style="margin-bottom: 10px;">
                    <div class="col-lg-4">
                      <span class="invoice-send-type-label" style="position: relative; top: 18px; font-weight: bold;">Skicka via:</span>
                    </div>
                    <div class="col-lg-8">
                      <mat-radio-group [disabled]="isInvoiceContentLocked()" class="example-radio-group invoice-send-type-group"
                                       [(ngModel)]="invoice.InvoiceSendType">
                        <mat-radio-button class="example-radio-button radiobuttonmargin" [disabled]="!canUpdateGeneral() || invoiceSendTypeLocked" *ngFor="let sendType of sendTypes" [value]="sendType.Id">{{sendType.Name}}</mat-radio-button>
                      </mat-radio-group>
                    </div>
                    <div class="col-12 px-0">
                      <div class="row invoice-email-row" *ngIf="invoice.InvoiceSendType == 1">
                        <div class="col-lg-4"><label class="bold" for="invoice-recipient-email">Mottagarens e-postadress*</label></div>
                        <div class="col-lg-8">
                          <mat-form-field floatLabel="always" color="accent" class="invoice-email-field">
                            <mat-label>Mottagarens e-postadress</mat-label>
                            <input id="invoice-recipient-email" type="email" matInput [required]="invoice.Customer?.Id > 0" [email]="invoice.Customer?.Id > 0" name="email"
                                   [disabled]="!canUpdateGeneral() || recieverEmailLocked" [(ngModel)]="invoice.RecieverEmail"
                                   (blur)="checkCorrectEmailFormat(invoice.RecieverEmail, 'RecieverEmail')" (focus)="clearErrorMessage('RecieverEmail')" />
                          </mat-form-field>
                          <div class="error-message">{{ErrorMessageRecieverEmail}}</div>
                        </div>
                      </div>
                      <div class="row invoice-email-row" *ngIf="invoice.InvoiceSendType == 1 || (invoice.InvoiceSendType == 3 && !invoice.Customer.GlnNumber)">
                        <div class="col-lg-4"><label class="bold" for="invoice-copy-email-0">Fakturakopia e-postadress</label></div>
                        <div class="col-lg-8">
                          <div class="invoice-copy-email-row" *ngFor="let address of invoiceCopyEmailAddresses; let i = index; trackBy: trackCopyEmailIndex">
                            <mat-form-field floatLabel="always" color="accent" class="invoice-email-field"
                                            [subscriptSizing]="i == invoiceCopyEmailAddresses.length - 1 ? 'dynamic' : 'fixed'">
                              <mat-label>Fakturakopia e-postadress</mat-label>
                              <input [id]="'invoice-copy-email-' + i" [name]="'invoice-copy-email-' + i" type="email" matInput [attr.autocomplete]="'section-invoice-copy-' + i + ' email'" [disabled]="!canUpdateGeneral()"
                                     [ngModel]="address" (ngModelChange)="updateInvoiceCopyEmail(i, $event)" />
                            </mat-form-field>
                            <button type="button" mat-icon-button [disabled]="!canUpdateGeneral()" (click)="removeInvoiceCopyEmail(i)"
                                    *ngIf="invoiceCopyEmailAddresses.length > 1 || address" aria-label="Ta bort kopieadress" matTooltip="Ta bort kopieadress"><mat-icon>close</mat-icon></button>
                          </div>
                          <div class="error-message" *ngIf="hasDuplicateInvoiceEmails" role="alert">Kopiemottagare får inte upprepas. Fakturans mottagaradress får inte användas för kopia eller påminnelse.</div>
                          <div class="error-message" *ngIf="ErrorMessageRecieverCopyEmail">{{ErrorMessageRecieverCopyEmail}}</div>
                          <div style="display: flex; justify-content: flex-end;"
                               [style.padding-right.px]="invoiceCopyEmailAddresses.length > 1 || invoiceCopyEmailAddresses[0] ? 56 : 0">
                            <button type="button" mat-button
                                    [disabled]="!canAddInvoiceCopyEmail()"
                                    (click)="addInvoiceCopyEmail()"><mat-icon aria-hidden="true">add</mat-icon>Lägg till fler mottagare av fakturakopia</button>
                          </div>
                        </div>
                      </div>
                      <div class="row invoice-email-row" *ngIf="invoice.InvoiceSendType == 1 || invoice.InvoiceSendType == 3">
                        <div class="col-lg-4"><label class="bold" for="invoice-reminder-email">{{invoice.InvoiceSendType == 3 ? 'E-post för eventuella påminnelser*' : 'Särskild e-post för påminnelser'}}<ng-container *ngIf="invoice.InvoiceSendType != 3"><br>(ej obligatorisk)</ng-container></label></div>
                        <div class="col-lg-8">
                          <mat-form-field floatLabel="always" color="accent" class="invoice-email-field">
                            <mat-label>E-post för påminnelser</mat-label>
                            <input id="invoice-reminder-email" name="invoice-reminder-email" type="email" matInput autocomplete="section-invoice-reminder email" [required]="invoice.InvoiceSendType == 3"
                                   [disabled]="!canUpdateGeneral()" [(ngModel)]="invoice.RecieverEmailReminder"
                                   (blur)="checkCorrectEmailFormat(invoice.RecieverEmailReminder, 'RecieverEmailReminder')" (focus)="clearErrorMessage('RecieverEmailReminder')" />
                          </mat-form-field>
                          <div class="error-message">{{ErrorMessageRecieverReminderEmail}}</div>
                        </div>
                      </div>
                      <div class="row" style="margin-top: 15px;" *ngIf="invoice.InvoiceSendType == 3">
                        <div class="col-lg-12" style="margin-bottom: 10px;">
                          <span *ngIf="invoice.Customer.GlnNumber">
                            Ditt angivna GLN-nummer för denna kund är: <span style="font-weight: bolder;" class="accent">{{ invoice.Customer.GlnNumber }}</span>.
                          </span>
                          <span *ngIf="!invoice.Customer.GlnNumber" style="margin-bottom:15px; display: block;">
                            Om din kund kräver GLN-nummer, lägg till det här (ej obligatoriskt):
                          </span>
                          <div class="row">
                            <div class="col-lg-6">
                              <mat-form-field floatLabel="always" class="gln-field">
                                <mat-label>GLN-nummer (enbart siffror)</mat-label>
                                <input [disabled]="isInvoiceContentLocked()" type="text"
                                       matInput
                                       [(ngModel)]="invoice.Customer.GlnNumber"
                                       pattern="[0-9]*"
                                       (keydown)="validateGln($event)" />
                              </mat-form-field>
                            </div>
                            <div class="col-lg-6">
                              <button [disabled]="isInvoiceContentLocked()" mat-flat-button color="accent" class="gln-save-button" (click)="updateCustomerGlnNumber(invoice.Customer.GlnNumber, invoice.Customer.Id)">Spara GLN-nummer</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="invoice.InvoiceSendType == 3" class="row" style="margin-bottom: 10px;">
                    <div class="col-lg-4">
                      <span class="bold">Elektronisk referens </span> <mat-icon color="accent" class="info-icon" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Om din kund kräver en elektronisk referens för att kunna hantera e-fakturan skriver du den här Enbart siffror är tillåtna.">info</mat-icon>
                    </div>
                    <div class="col-lg-8">
                      <div class="invoice-marking-field">
                        <input class="invoiceinput"
                               type="text"
                               [disabled]="!canUpdateGeneral()"
                               matInput
                               [(ngModel)]="invoice.ReferenceText"
                               placeholder="Unik fakturareferens"
                               inputmode="numeric"
                               pattern="[0-9]*"
                               (keypress)="allowOnlyDigits($event)" />
                      </div>
                      <span *ngIf="electronicReferenceMandatory" style="font-size: 80%; font-style: italic;">
                        Din kund kräver elektronisk referens på e-fakturor. Om du inte fått info från din kund behöver du fråga din kund efter elektronisk referens på e-fakturor. Enbart siffror är tillåtna.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--<div style="margin-left: 20px; margin-bottom:40px;" *ngIf="invoice.InvoiceSendType == 2">

          <div *ngIf="invoice?.Customer.Id > 0">
            <p>
              Angiven mottagaradress:
            </p>

            <span class="bold">{{invoice.RecieverCompanyName}}</span><br />
            <span>Att: {{invoice.RecieverAtt}}</span><br />
            <span>{{invoice.RecieverAddress1}}</span> <span>{{invoice.RecieverAddress2}}</span><br />
            <span>{{invoice.RecieverZip}} {{invoice.RecieverCity}}</span><br /><br />

            <p>
              <span style="font-style: italic; margin-top: 15px;">
                Om adressen inte stämmer, redigera din kund:
                <anms-big-input-action icon="edit" color="accent"
                                       (action)="editCustomer()"
                                       [disabled]="!canUpdateGeneral()"
                                       matTooltip="Redigera" matTooltipPosition="before">
                </anms-big-input-action>
              </span>
            </p>
          </div>
        </div>-->

          <div *ngIf="!invoice?.SubInvoice" class="row">
            <div style="margin-bottom: 17px;" class="col-sm-12 col-md-12 col-lg-12">
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-lg-4">
                  <span class="bold">Fakturaavgiften ({{invoice.InvoiceFee}} kr) betalas av: </span>
                </div>
                <div class="col-lg-8">
                  <mat-checkbox [disabled]="!canUpdateGeneral() || invoiceFeeLocked" [(ngModel)]="invoice.FeePaidByReciever" (change)="invoice.FeePaidByReciever = $event.checked;">Kunden</mat-checkbox>
                  <mat-checkbox [disabled]="!canUpdateGeneral() || invoiceFeeLocked" [ngModel]="!invoice.FeePaidByReciever" (ngModelChange)="invoice.FeePaidByReciever = $event" (change)="invoice.FeePaidByReciever = !$event.checked;" style="margin-left:15px;">Mig <i style="font-size: 13px;">(ca 15 kr netto)</i></mat-checkbox>
                  <div *ngIf="!isAdmin && invoice.Customer.AcceptsInvoiceFeeLocked && !invoice.Customer.AcceptsInvoiceFee" style="font-size: 80%; font-style: italic;">
                    Denna kund godkänner inte att du fakturerar dem för fakturaavgiften
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="!hasSubInvoices">
            <div style="margin-bottom: 17px;" class="col-sm-12 col-md-12 col-lg-12">
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-lg-4">
                  <span class="bold">Expressutbetalning? <mat-icon color="accent" class="info-icon" matTooltipPosition="after" aria-label="Hover to display info" [matTooltip]="expressPayoutTooltip">info</mat-icon></span>
                </div>
                <div class="col-lg-8">
                  <mat-radio-button class="ml-2 radiobuttonmargin"
                                    [checked]="!invoice.ExpressPayOut"
                                    #rbExpressPayoutNo
                                    [disabled]="isInvoiceContentLocked() || (!canUseExpressPayout() || (!isAdmin && isExpressPayoutBlockedByDueDate()))"
                                    [value]="false"
                                    (click)="expressPayoutClick(false, $event)"
                                    id="rbExpressPayoutNo">
                    Nej
                  </mat-radio-button>

                  <div class="col-lg-12 error-message" style="margin-top: 15px;" *ngIf="invoice?.Status?.TechnicalName != 'Draft' && ((+invoice?.PaymentTerm || 0) > 30)">
                    {{expressPayoutMessages.sentPaymentTerm}}
                  </div>
                  <mat-radio-button class="ml-2 radiobuttonmargin"
                                    [checked]="invoice.ExpressPayOut"
                                    #rbExpressPayoutYes
                                    [disabled]="isInvoiceContentLocked() || expressCustomerCheckBusy || expressCustomerBlocked || !canUseExpressPayout()"
                                    [value]="true"
                                    (click)="expressPayoutClick(true, $event)"
                                    id="rbExpressPayoutYes">
                    Ja
                  </mat-radio-button>
                  <span *ngIf="expressCustomerCheckBusy" class="ml-2" role="status">Kontrollerar kunden…</span>
                  <div class="ml-2 mt-2" *ngIf="invoice.Customer.Id > 0 && !invoice.Customer.IsCompany && !invoice.SubInvoice">
                    {{expressPayoutMessages.companyRequired}}
                  </div>
                  <div *ngIf="expressCustomerWarning || (invoice.DeniedForExpress && invoice.ExpressDenialReason)" class="ml-2 mt-2" style="color: red;" role="alert">
                    {{expressCustomerWarning || invoice.ExpressDenialReason}}
                    <ng-container *ngIf="expressCustomerBlocked || (invoice.DeniedForExpress && invoice.ExpressDenialReason)"> {{expressPayoutMessages.contactSupport}} <a href="mailto:support@samgruppen.se">support&#64;samgruppen.se</a> {{expressPayoutMessages.moreInformation}}</ng-container>
                  </div>
                  <div class="ml-2 mt-2" style="color: red;" role="alert" *ngIf="!ContactEmailApprovedForExpress && !invoice.SubInvoice && invoice.ExpressPayOut">
                    {{expressPayoutMessages.freeEmail}}
                    {{expressPayoutMessages.contactSupport}} <a href="mailto:support@samgruppen.se">support&#64;samgruppen.se</a> {{expressPayoutMessages.moreInformation}}
                  </div>
                </div>
                <div class="col-12 col-lg-8 offset-lg-4" style="margin-top: 15px;" *ngIf="showExpressPayoutDueDateWarning()">
                  {{expressPayoutMessages.dueDate}} {{ invoice.PaymentDue | swedishDate : 'yyyy-MM-dd' }}
                </div>
                <div class="col-12 col-lg-8 offset-lg-4" style="margin-top: 15px;" *ngIf="(+invoice?.PaymentTerm || 0) > 30">
                  {{expressPayoutMessages.paymentTerm}}
                </div>
                <div class="col-12 col-lg-8 offset-lg-4" *ngIf="invoice.Customer.Country?.Name != 'Sverige'">
                  {{expressPayoutMessages.swedishCustomerRequired}}
                </div>
                <div class="col-12 col-lg-8 offset-lg-4" *ngIf="invoice.Currency.Name != 'SEK'">
                  {{expressPayoutMessages.sekRequired}}
                </div>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
      <!--<mat-form-field floatLabel="always" *ngIf="!invoice.SubInvoice" class="col-3">
  <mat-label>Kampanjkod</mat-label>
      <input type="text" [(ngModel)]="DiscountCode" matInput disabled />
    </mat-form-field>-->
      <div class="col-lg-6" *ngIf="pensionSavingsTotalAmount > 0 || pensionSavingsPercent > 0" style="margin-bottom:20px;">
        <mat-form-field floatLabel="always" style="margin-right: 10px; width: 100%;">
          <mat-label>{{invoice.Currency.Name == 'SEK' ? 'Total tjänstepension inkl skatt för denna faktura' : 'Avsättning i % av fakturabeloppet'}}</mat-label>
          <input *ngIf="invoice.Currency.Name == 'SEK'" class="text-input" matInput disabled [(value)]="pensionSavingsTotalAmount">
          <input *ngIf="invoice.Currency.Name != 'SEK'" class="text-input" matInput disabled [(value)]="pensionSavingsPercent">
        </mat-form-field>
        <div *ngIf="invoice.Currency.Name == 'SEK'">Du har angett att du vill avsätta {{pensionSavingsTotalAmount}} {{invoice.Currency.Name}} (inkl skatt) till din tjänstepension. <span class="error-message" *ngIf="errorMessagePension != ''">{{errorMessagePension + '.'}}</span> Under punkt 4 kan du ändra för denna faktura.</div>
        <div *ngIf="invoice.Currency.Name != 'SEK'">Du har angett att du vill avsätta {{pensionSavingsPercent}} % av lönebaserande belopp till din tjänstepension. <span class="error-message" *ngIf="errorMessagePension != ''">{{errorMessagePension + '.'}}</span> Under punkt 4 kan du ändra för denna faktura.</div>
      </div>
      <div class="col-lg-8 offset-lg-4" style="margin-bottom:20px;">
        <div class="terms-links">
          <a class="accent" [href]="fileService.buildPublicDocumentUrl('AllmannaVillkorEgenanstalld.pdf')" target="_blank">Allmänna villkor för egenanställd</a> |
          <a class="accent" [href]="fileService.buildPublicDocumentUrl('AllmannaVillkorKund.pdf')" target="_blank">Allmänna villkor för kund</a> |
          <a class="accent" [href]="fileService.buildPublicDocumentUrl('Integritetspolicy.pdf')" target="_blank">Integritetspolicy</a>
        </div>

        <div style="text-align: right;">
          <mat-checkbox [disabled]="isInvoiceContentLocked()" label="Härmed godkänner jag"
                        *ngIf="invoice"
                        [(ngModel)]="invoice.termsAgreed">
            Härmed godkänner jag villkor och integritetspolicy
          </mat-checkbox>
        </div>
      </div>

      <div class="col-lg-8 invoice-actions-left">
        <button mat-flat-button color="primary" class="col-sm-6 col-lg-4" (click)="cancel()">Avbryt</button>
        <button *ngIf="!invoice.SubInvoice"
                style="margin-left: 5px;"
                mat-stroked-button
                [class.disabled]="isLoading || invoiceGroupSaving || !sendValidates(true) || !canUpdateInvoice()"
                [disabled]="isLoading || invoiceGroupSaving || !sendValidates(true) || !canUpdateInvoice()"
                (click)="handleSendClick(invoice)">
          Begär offert
        </button>
        <button mat-stroked-button class="preview-btn" style="margin-left: 5px;" (click)="openInvoicePreview()" [disabled]="!validPreview()">Förhandsgranska</button>
        <button mat-stroked-button class="preliminary-salary-button" style="margin-left: 5px;" (click)="openPreliminarySalaryDialog()" [disabled]="!hasPreliminarySalaryAmount() || invoiceHasBeenSent()">Preliminär löneberäkning</button>

      </div>
      <div class="col-sm-6 col-lg-4 buttonrow invoice-actions-right">
        <!--<button mat-stroked-button (click)="preview(invoice)" [disabled]="isLoading || !validPreview()">Sammanställning</button>-->
        <button mat-stroked-button *ngIf="invoice.Status.TechnicalName != 'Draft'" (click)="saveDraft(invoice)" [disabled]="isInvoiceContentLocked() || (isLoading || invoiceGroupSaving)">Spara</button>
        <button mat-stroked-button *ngIf="invoice.Status.TechnicalName == 'Draft'" (click)="saveDraft(invoice)" [disabled]="isLoading || invoiceGroupSaving || !canUpdateInvoiceDraft()">Spara utkast</button>
        <button *ngIf="!invoice.SubInvoice" mat-flat-button (click)="send(invoice)" [disabled]="isLoading || invoiceGroupSaving || !sendValidates() || !canUpdateInvoice() || !sendInvoiceValidates" color="accent">Skicka faktura</button>
      </div>
      <div class="col-lg-12 invoice-warning-row">
        <span *ngIf="!invoice.SubInvoice" class="invoice-warning-message" [innerHTML]="requiresPensionSavingsCompany() ? 'Du måste ange ett företag för din pensionsavsättning' : ErrorMessageSend"></span><br />
        <span *ngIf="invoice?.CreditInvoiceFor != null" class="invoice-warning-message">Observera att detta är en <b>kreditfaktura</b>. Den kommer att kvitta din ordinarie faktura. </span>
      </div>

      <div class="col-sm-12" *ngIf="!invoice.SubInvoice">
        <mat-card>

          <div class="row paddingbottom">
            <div class="col-lg-9">
              <mat-card-title>Rabattkod</mat-card-title>
              <p *ngIf="false && referralCode">
                Vi har automatiskt lagt till din värvningsrabatt på denna faktura, du behöver inte göra något.<br>
                <span style="font-weight: bold;">Din rabatt: {{ referralDiscountText }}</span>
              </p>


              <div *ngIf="!referralCode">
                <p>
                  Ange din rabattkod här för att lösa in din rabatt.
                </p>
                <mat-form-field floatLabel="always" style="margin-right: 10px;">
  <mat-label>Kod</mat-label>
                  <input [disabled]="isInvoiceContentLocked()" class="text-input" matInput type="text" [(ngModel)]="code">
                </mat-form-field>

                <button mat-flat-button color="accent" class="discount-redeem-button" [disabled]="code == null" (click)="addDiscountCode(code)">
                  <mat-icon>add</mat-icon> Lös in
                </button>
              </div>

              <!-- Visa giltiga rabattkoder här -->
              <div *ngIf="invoice.DiscountCodes?.length > 0 && !referralCode" class="discount-code-container">
                <h3>Dina tillgängliga rabattkoder</h3>

                <mat-list>
                  <ng-container *ngFor="let discount of invoice.DiscountCodes; let i = index">
                    <mat-list-item>
                      <mat-icon matListIcon color="primary">local_offer</mat-icon>

                      <div matLine class="code-line">
                        <span class="code">{{ discount.Code }}</span>
                        <span class="id">(#{{ discount.Id }})</span>
                      </div>

                      <div matLine class="details-line">
                        <span class="discount-value">
                          {{
                            discount.Category === DiscountCategory.Percentage
                              ? discount.DiscountPercentage + '% rabatt'
                              : discount.FixedDiscountAmount + ' kr rabatt'
                          }}
                        </span>
                        <span class="discount-type">
                          på {{ discount.Type === DiscountType.ServiceFee ? 'serviceavgiften' : 'fakturaavgiften' }}
                        </span>
                      </div>

                      <button mat-icon-button color="warn" class="delete-btn" (click)="removeDiscountCode(i)">
                        <mat-icon>delete_outline</mat-icon>
                      </button>
                    </mat-list-item>
                  </ng-container>
                </mat-list>
              </div>

            </div>
            <div class="col-lg-3">
            </div>
          </div>
        </mat-card>
      </div>
    </div>

    <div *ngIf="!isLoading && invoice.CreditInvoiceFor == null" class="row align-items-end section">
      <div id="invoice-payout-section" class="col-sm-12 d-flex justify-content-start invoice-section-heading">
        <span class="invoice-section-heading-icon" aria-hidden="true"><mat-icon>account_balance_wallet</mat-icon></span>
        <h2>4. Uppgifter för din utbetalning<mat-icon color="accent" class="info-icon" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Om din kund ska ersätta dig för dina utgifter måste du addera detta till fakturan under punkt 2!">info</mat-icon></h2>
      </div>
      <!-- 4 Utbetalning -->
      <div class="col-sm-12 col-md-12 payout-options-group">
        <!-- PERSONUPPGIFTER -->
        <!--<mat-card class="col-sm-12" *ngIf="!hasSubInvoices && (bankInfoNeedsUpdate || userEmailNeedsUpdate || userPersonalNumberNeedsUpdate || userPhoneNumberNeedsUpdate)">
          <div class="row paddingbottom">
            <div class="col-lg-12">
              <mat-card-title>Personuppgifter </mat-card-title>
              <p>
                Vi saknar uppgifter om dig. Du behöver ange dem för att vi ska kunna skicka fakturan och betala ut din lön.
              </p>-->
              <!--Bankuppgifter saknas-->
              <!--<div *ngIf="bankInfoNeedsUpdate">
                <div class="col-12 row">

                  <mat-form-field floatLabel="always" style="width: 100%;">
                    <mat-label>Bank</mat-label>
                    <mat-select [disabled]="isInvoiceContentLocked()" [(ngModel)]="invoiceSender.Bank.Id"
                                name="bank"
                                pattern="^[1-9][0-9]?$"
                                (ngModelChange)="bankOnChange($event)">
                      <mat-option *ngFor="let b of banks" [value]="b.Id">
                        {{ b.Name }}
                      </mat-option>
                    </mat-select>
                    <mat-error>Välj bank</mat-error>
                  </mat-form-field>

                </div>

                <div class="row" *ngIf="invoiceSender.Bank.IsInternational" style="margin-bottom: 15px;">

                  <div class="col-sm-6">
                    <mat-form-field style="width: 100%" floatLabel="always">
  <mat-label>BIC</mat-label>
                      <input [disabled]="isInvoiceContentLocked()" matInput
                             [ngModel]="invoiceSender?.Bic"
                             (ngModelChange)="invoiceSender.Bic = $event"
                            
                             id="bic"
                             pattern="^(?:[a-zA-Z0-9]{8}|[a-zA-Z0-9]{11})$"
                             name="bic">
                      <mat-error>Ange 8 eller 11 bokstäver och siffror</mat-error>
                      <mat-hint>Ange 8 eller 11 bokstäver och siffror</mat-hint>
                    </mat-form-field>
                  </div>

                  <div class="col-sm-6">
                    <mat-form-field style="width: 100%" floatLabel="always">
  <mat-label>IBAN</mat-label>
                      <input [disabled]="isInvoiceContentLocked()" matInput
                             [ngModel]="invoiceSender.Iban"
                             (ngModelChange)="invoiceSender.Iban = $event"
                            
                             id="iban"
                             pattern="[a-zA-Z0-9]{0,34}"
                             name="iban">
                      <mat-error>Ange upp till 34 bokstäver och siffror</mat-error>
                      <mat-hint>Ange upp till 34 bokstäver och siffror</mat-hint>
                    </mat-form-field>
                  </div>

                </div>

                <div class="row" *ngIf="invoiceSender?.Bank?.Id == 0 || !invoiceSender?.Bank.IsInternational" style="margin-bottom: 15px;">

                  <div class="col-sm-6" *ngIf="invoiceSender?.Bank?.Id == 0 || invoiceSender?.Bank?.ClearingRequired">
                    <mat-form-field style="width: 100%" floatLabel="always">
  <mat-label>Clearingnummer</mat-label>
                      <input [disabled]="isInvoiceContentLocked()" matInput [ngModel]="invoiceSender?.ClearingNumber"
                             (ngModelChange)="invoiceSender.ClearingNumber = $event"
                            
                             id="ClearingNumber"
                             name="ClearingNumber"
                             pattern="{{invoiceSender?.Bank.ClearingNumberValidationRegex}}">
                      <mat-error>
                        {{invoiceSender?.Bank.ClearingNumberValidationErrorText}}
                      </mat-error>
                      <mat-hint>
                        {{invoiceSender?.Bank.ClearingNumberValidationErrorText}}
                      </mat-hint>
                    </mat-form-field>
                  </div>

                  <div class="col-sm-6" *ngIf="user?.Bank?.Id == 0 || user.Bank.Id > 0">
                    <mat-form-field style="width: 100%" floatLabel="always">
  <mat-label>Kontonummer</mat-label>
                      <input [disabled]="isInvoiceContentLocked()" matInput [ngModel]="invoiceSender?.AccountNumber"
                             (ngModelChange)="invoiceSender.AccountNumber = $event"
                            
                             id="AccountNumber"
                             name="AccountNumber"
                             pattern="{{invoiceSender?.Bank.AccountNumberValidationRegex}}">
                      <mat-error>
                        {{invoiceSender?.Bank.AccountNumberValidationErrorText}}
                      </mat-error>
                      <mat-hint>
                        {{invoiceSender?.Bank.AccountNumberValidationErrorText}}
                      </mat-hint>
                    </mat-form-field>
                  </div>
                </div>
              </div>-->
              <!-- / Bankuppgifter saknas-->
              <!-- Personnr saknas-->
              <!--<div *ngIf="userPersonalNumberNeedsUpdate">
                <mat-form-field class="row col-lg-6" floatLabel="always">
  <mat-label>Personnummer / samordningsnummer</mat-label>
                  <input [disabled]="isInvoiceContentLocked()" matInput [(ngModel)]="missingPersonalNumber" ngModel pattern="[0-9]{12}" maxlength="12" id="PersonalNumber" name="PersonalNumber">
                </mat-form-field>
              </div>-->
              <!-- / Personnr saknas-->
              <!-- Email saknas-->
              <!--<div *ngIf="userEmailNeedsUpdate">
                <mat-form-field class="row col-lg-6" floatLabel="always">
  <mat-label>E-post</mat-label>
                  <input [disabled]="isInvoiceContentLocked()" matInput [(ngModel)]="missingEmail" id="email" name="email">
                </mat-form-field>
              </div>-->
              <!-- / Email saknas-->
              <!-- Telefonnr saknas-->
              <!--<div *ngIf="userPhoneNumberNeedsUpdate">
                <mat-form-field class="row col-lg-6" floatLabel="always">
  <mat-label>Telefon</mat-label>
                  <input [disabled]="isInvoiceContentLocked()" matInput [(ngModel)]="missingPhone" id="telephone" name="telephone">
                </mat-form-field>
              </div>-->
              <!-- / Telefonnr saknas-->

              <!--<button mat-raised-button
                      (click)="saveUserContactAndBankInfo()"
                      [disabled]="userInfoSaveValid()"
                      color="accent">
                Spara uppgifter
              </button>

            </div>
          </div>
        </mat-card>-->
        <!-- PERSONUPPGIFTER -->

        <mat-card class="col-sm-12 invoice-toggle-card" *ngIf="!hasSubInvoices">
          <div class="row">
            <div class="col-lg-12">
              <button type="button" class="invoice-toggle" (click)="payoutDeductionsToggleOpen = !payoutDeductionsToggleOpen">
                <mat-card-title>Kostnader / utlägg / reseutlägg </mat-card-title>
                <mat-icon>{{ payoutDeductionsToggleOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
              <div *ngIf="payoutDeductionsToggleOpen" class="invoice-toggle-content">
                <p class="paymentinfo">
                  Har du gjort inköp eller haft kostnader i samband med ditt jobb kan du få tillbaka den kostnaden skattefritt.
                  Uppge belopp samt ladda upp underlag (kvitton, faktura osv) här. Även biljetter för resor lägger du till här.
                </p>
                <button [disabled]="isInvoiceContentLocked()" mat-flat-button color="accent" (click)="editDeduction('')" style="height:42px;">
                  <mat-icon>add</mat-icon> Kostnader / utlägg / reseutlägg
                </button>
              </div>
            </div>
            <div class="col-lg-12" *ngIf="payoutDeductionsToggleOpen">
              <!-- Added deductions -->
              <div>
                <div *ngFor="let c of invoice.Deductions" class="time-group payout-item-card">
                  <div style="display: inline-block; width: 100%;">
                    <span><b>Kostnader / utlägg / reseutlägg</b></span>
                    <span style="float: right;">
                      <span *ngIf="c.DeniedByAdmin && !c.ApprovedByAdmin" style="color: red;">Ej godkänt</span>
                      <span *ngIf="!c.DeniedByAdmin && c.ApprovedByAdmin" style="color: green;">Godkänt</span>
                      <span *ngIf="!c.DeniedByAdmin && !c.ApprovedByAdmin" style="color: black;">Granskas</span>
                    </span>
                    <br />
                    <div *ngIf="c.AddedToInvoice == false && !invoice.SubInvoice" class="payout-billing-state">
                      <i>Faktureras ej till kund</i>
                    </div>
                    <div *ngIf="c.AddedToInvoice == true && !invoice.SubInvoice" class="payout-billing-content">
                      <div class="payout-billing-state"><i>Faktureras kund</i></div>
                      <strong>{{c.Name}}</strong><i> (denna rad visas på fakturan)</i>
                    </div>
                    {{c.Description}}<br />
                    <b><span class="error-message" *ngIf="!c.Attachment?.Guid">Det saknas kvitto till detta utlägg</span></b>

                    <div class="payout-item-actions">
                      <div [hidden]="!isAdmin && ((c.AddedToInvoice && !canUpdateGeneral()) || (c.AddedToInvoice && invoice.SubInvoice))" class="editbutton payout-item-edit" (click)="editDeduction('', c)"><mat-icon class="edit-icon">edit</mat-icon></div>
                      <div [hidden]="!isAdmin && ((c.AddedToInvoice && !canUpdateGeneral()) || (c.AddedToInvoice && invoice.SubInvoice))" class="editbutton payout-item-delete" (click)="deleteDeduction(c)"><mat-icon>delete</mat-icon></div>
                    </div>
                  </div>
                  <div class="deduction-document-actions" *ngIf="c.Attachment?.Guid || c.Attachment?.Url || c.AttachmentReciept?.Guid || c.AttachmentReciept?.Url">
                    <button type="button" mat-stroked-button *ngIf="c.Attachment?.Guid || c.Attachment?.Url" (click)="showFile(c.Attachment)">Visa kvitto</button>
                    <button type="button" mat-stroked-button *ngIf="c.AttachmentReciept?.Guid || c.AttachmentReciept?.Url" (click)="showFile(c.AttachmentReciept)">Visa betalningskvittens</button>
                  </div>
                  <div class="d-flex justify-content-between payout-item-total">
                    <div class="col" style="padding-left: 0px;">
                      <span class="row-total-amount">Skattefritt utlägg: {{c.Amount}} SEK</span>
                      <span class="row-total-amount" *ngIf="c.AddedToInvoice">Faktureras kund: {{c.AgreedInvoiceAmount != null ? c.AgreedInvoiceAmount : c.Amount}} SEK</span>
                    </div>
                  </div>
                  <div class="col-lg-12 warning-box" *ngIf="c.DeniedReason && c.DeniedReason.trim().length > 0">
                    <span>{{c.DeniedReason}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-card>

        <mat-card class="col-sm-12 invoice-toggle-card" *ngIf="!hasSubInvoices">
          <div class="row">
            <div class="col-lg-12">
              <button type="button" class="invoice-toggle" (click)="payoutAllowancesToggleOpen = !payoutAllowancesToggleOpen">
                <mat-card-title>Traktamente och milersättning </mat-card-title>
                <mat-icon>{{ payoutAllowancesToggleOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
              <div *ngIf="payoutAllowancesToggleOpen" class="invoice-toggle-content">
                <p class="paymentinfo">
                  Har du rätt till traktamenten eller milersättning när du jobbat på annan ort eller utomlands så lägger du in uppgifter för dina resor här.
                </p>
                <button [disabled]="isInvoiceContentLocked()" mat-flat-button color="accent" (click)="editAllowance('notAdded')" style="height:42px;">
                  <mat-icon>add</mat-icon> Milersättning / traktamente
                </button>
              </div>
            </div>
            <div class="col-lg-12" *ngIf="payoutAllowancesToggleOpen">
              <!-- Added allowances -->
              <div [hidden]="!canUpdatePayout()">
                <div *ngFor="let c of invoice.Allowances" class="time-group payout-item-card">
                  <div style="display: inline-block; width: 100%;">
                    <b>{{getAllowanceTypeName(c?.AllowanceType?.Id)}}</b>
                    <span style="float: right;">
                      <span *ngIf="c.DeniedByAdmin && !c.ApprovedByAdmin" style="color: red;">Ej godkänt</span>
                      <span *ngIf="!c.DeniedByAdmin && c.ApprovedByAdmin" style="color: green;">Godkänt</span>
                      <span *ngIf="!c.DeniedByAdmin && !c.ApprovedByAdmin" style="color: black;">Granskas</span>
                    </span>
                    <br />
                    <div *ngIf="c.AddedToInvoice == false" class="payout-billing-state">
                      <i>Faktureras ej till kund</i>
                    </div>
                    <div *ngIf="c.AddedToInvoice == true" class="payout-billing-state">
                      <i>Faktureras kund</i>
                    </div>
                    <span>Skattefri reseersättning: {{c.Sum  | number : '1.2-2' }} SEK</span><br />
                    <span>Faktureras kund: {{ (c.AddedToInvoice ? (c.CustomReimbursementPerKm !== 0 && c.sumCustomReimbursementPerKm ? c.sumCustomReimbursementPerKm : c.Sum) : 0) | number : '1.2-2' }} SEK</span><br />
                    <span *ngIf="c.Mileage > 0">{{c.Mileage}} km <br /></span>
                    {{c.TravelDateStart  | swedishDate: 'yyyy-MM-dd'}} {{c.TravelDateEnd != null ? ' - ' + (c.TravelDateEnd  | swedishDate: 'yyyy-MM-dd')  : ''}} {{ c.CarRegistrationNumber != null ? ' : ' + c.CarRegistrationNumber : '' }}
                    <div class="payout-item-actions">
                      <button [disabled]="isInvoiceContentLocked()" type="button" mat-icon-button [hidden]="(c.AddedToInvoice == true && !canUpdateGeneral()) || (c.AddedToInvoice && invoice.SubInvoice)" class="payout-item-edit" aria-label="Redigera milersättning" matTooltip="Redigera milersättning" (click)="editAllowance('', c)"><mat-icon class="edit-icon">edit</mat-icon></button>
                      <button [disabled]="isInvoiceContentLocked()" *ngIf="c?.AllowanceType?.Id == 1 || c?.AllowanceType?.Id == '1'" type="button" mat-icon-button [hidden]="(c.AddedToInvoice == true && !canUpdateGeneral()) || (c.AddedToInvoice && invoice.SubInvoice)" class="payout-item-copy" aria-label="Kopiera milersättning" matTooltip="Kopiera milersättning" (click)="copyMileageAllowance('', c)"><mat-icon>content_copy</mat-icon></button>
                      <button [disabled]="isInvoiceContentLocked()" type="button" mat-icon-button [hidden]="(c.AddedToInvoice == true && !canUpdateGeneral()) || (c.AddedToInvoice && invoice.SubInvoice)" class="payout-item-delete" aria-label="Radera milersättning" matTooltip="Radera milersättning" (click)="deleteAllowance(c)"><mat-icon>delete</mat-icon></button>
                    </div>
                  </div>
                  <!--<div class="d-flex justify-content-between" style="margin-top: 10px;">
                    <div class="col" style="padding-left: 0px;">
                      <span class="row-total-amount">Faktureras kund: {{ (c.AddedToInvoice ? (c.CustomReimbursementPerKm !== 0 && c.sumCustomReimbursementPerKm ? c.sumCustomReimbursementPerKm : c.Sum) : 0) | number : '1.2-2' }} SEK</span>
                    </div>
                  </div>-->
                  <div class="col-lg-12 warning-box" *ngIf="c.DeniedReason && c.DeniedReason.trim().length > 0">
                    <span>{{c.DeniedReason}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-card>

        <mat-card class="col-sm-12 invoice-toggle-card">
          <div class="row">
            <div class="col-lg-12">
              <button type="button" class="invoice-toggle" (click)="payoutPensionToggleOpen = !payoutPensionToggleOpen">
                <mat-card-title>Avsättning till tjänstepension</mat-card-title>
                <mat-icon>{{ payoutPensionToggleOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
              <div *ngIf="payoutPensionToggleOpen" class="invoice-toggle-content paymentinfo">
                <div *ngIf="!invoiceSender?.PensionSavingsSettings?.PensionSavingsCompany?.Id || invoiceSender?.PensionSavingsSettings?.PensionSavingsCompany?.Id == 3" style="margin-bottom: 15px;">Du har inget pensionsbolag angivet i dina inställningar. Du behöver välja ett för att vi ska kunna betala in din pensionsavsättning.</div>

                <div class="row">
                  <div class="col-lg-6" style="margin-left: 0; padding-left: 0;">
                    <mat-form-field floatLabel="always" class="pension-company-field">
                      <mat-label>Tjänstepensionsföretag</mat-label>
                      <mat-select [disabled]="isInvoiceContentLocked()" [ngModel]="invoiceSender?.PensionSavingsSettings?.PensionSavingsCompany?.Id"
                                  (ngModelChange)="pensionSavingsCompanyChanged($event); updatePensionSavingsCompany($event)"
                                  [ngModelOptions]="{standalone: true}">
                        <mat-option [value]="1">SPP</mat-option>
                        <mat-option [value]="2">Avanza</mat-option>
                        <mat-option [value]="3">Inget valt</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <p class="paymentinfo" style="margin: 0;">
                  Avsätt till tjänstepension för denna faktura. Du kan om du vill förinställa pension i dina inställningar. Det är alltid möjligt att ändra den här.
                  <br />
                  <span *ngIf="invoice.Currency.Name != 'SEK'" style="font-style: italic;">Du har skapat ett underlag i utländsk valuta, och pensionsbeloppet beräknas när fakturan är betald och växelkursen är känd.</span>
                </p>
              </div>
            </div>
            <div class="col-lg-12" *ngIf="payoutPensionToggleOpen && (pensionSavingsFactorPreset > 0 || pensionSavingsAmountPreset > 0)">
              <div class="payment-part-body">
                <div *ngIf="pensionSavingsFactorPreset > 0">
                  <mat-form-field floatLabel="always" style="margin-right: 10px;">
  <mat-label>Förinställd procentandel</mat-label>
                    <input class="text-input" matInput disabled [(ngModel)]="pensionSavingsFactorPreset">
                  </mat-form-field><span> %</span>
                </div>

                <div *ngIf="pensionSavingsAmountPreset > 0">
                  <mat-form-field floatLabel="always" style="margin-right: 10px;">
  <mat-label>Förinställt fast belopp</mat-label>
                    <input class="text-input" matInput disabled type="number" [(ngModel)]="pensionSavingsAmountPreset">
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="pension-percent-column" [ngClass]="invoice.Currency.Name == 'SEK' ? 'col-lg-3' : 'col-lg-12'" *ngIf="payoutPensionToggleOpen">
              <div class="payment-part-body">
                <mat-form-field floatLabel="always" style="margin-right: 10px;">
  <mat-label>Avsättning i % av slutgiltig bruttolön</mat-label>
                  <input class="text-input" matInput [disabled]="!canUpdatePayout() || hasSubInvoices" type="number" [(ngModel)]="pensionSavingsPercent" (ngModelChange)="updatePensionSavingsAmount('Share')">
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 pension-amount-column" *ngIf="payoutPensionToggleOpen && invoice.Currency.Name == 'SEK'">
              <div class="payment-part-body">
                <mat-form-field floatLabel="always" style="margin-right: 10px;">
  <mat-label>Tjänstepension exkl skatt</mat-label>
                  <input class="text-input" matInput [disabled]="!canUpdatePayout() || hasSubInvoices || invoice.Currency.Name != 'SEK'" type="number" step="1" [ngModel]="pensionSavingsAmountForDisplay" (ngModelChange)="pensionSavingsAmount = $event; updatePensionSavingsAmount('Amount')">
                  <mat-hint style="font-size: 80%; font-style: italic;">
                    <ng-container *ngIf="getMaxPensionSavingsAmountExclTax() !== null; else pensionLimitUnavailable">
                      Max {{getMaxPensionSavingsAmountExclTax()}} kr
                    </ng-container>
                    <ng-template #pensionLimitUnavailable>Maxbeloppet kan inte beräknas innan skatteuppgifterna har hämtats.</ng-template>
                  </mat-hint>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 pension-total-column" *ngIf="payoutPensionToggleOpen && invoice.Currency.Name == 'SEK'">
              <div class="payment-part-body">
                <mat-form-field floatLabel="always" style="margin-right: 10px;">
  <mat-label>Total tjänstepension inkl skatt</mat-label>
                  <input class="text-input" matInput disabled [(value)]="pensionSavingsTotalAmount">
                  <!--<span matSuffix>{{invoice.Currency.Name}}</span>-->
                </mat-form-field>
              </div>
              <span class="error-message">{{errorMessagePension}}</span>
            </div>
            <div class="col-lg-9 pension-description-column" *ngIf="payoutPensionToggleOpen">
              <p class="error-message" role="alert" *ngIf="pensionLimitWarning">
                {{pensionLimitWarning}} {{isAdmin ? 'Du kan som administratör spara fakturan ändå. Gränsen kontrolleras igen vid slutlig utbetalning.' : 'Sänk pensionsavsättningen innan du sparar.'}}
              </p>
              <p style="margin-top: 10px;">
                Du får avsätta max 35 % av den slutgiltiga bruttolön, exklusive pensionsskatt. Om beloppet överstiger 35 % vid utbetalningen kommer vi att justera detta.
                <br /><br />
                Tjänstepension samt tjänstepensionsskatten på 24,26 % kommer att dras från ditt lönegrundande belopp.
                <br /><br />
                Löneväxling kan minska allmän pension, sjukpenning, föräldrapenning och andra socialförsäkringsförmåner om bruttolönen efter löneväxling blir lägre än 56 100 kr/mån (2026).
              </p>
            </div>
          </div>
        </mat-card>

        <mat-card *ngIf="!invoice.SubInvoice" class="col-sm-12 invoice-toggle-card">
          <div class="row">
            <div class="col-lg-12">
              <button type="button" class="invoice-toggle" (click)="payoutSalarySharesToggleOpen = !payoutSalarySharesToggleOpen">
                <mat-card-title>Delning av lön</mat-card-title>
                <mat-icon>{{ payoutSalarySharesToggleOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
              <div *ngIf="payoutSalarySharesToggleOpen" class="invoice-toggle-content">
                <p class="paymentinfo">
                  Du kan dela med dig av löneutbetalning om du jobbat med någon eller några andra.<br />
                  Fyll i personnummer och andel som ska delas ut här. Ange procentandel eller hur kronor av fakturabeloppet du vill dela med dig av, beroende på vald delningstyp. Tänk på att arbetsgivaravgift och skatt dras även från din medarbetares lönesumma.
                </p>
                <button *ngIf="!hasSubInvoices" mat-raised-button color="accent" [disabled]="!canUpdatePayout()" (click)="addSalaryShare()" style="height:42px;">
                  <mat-icon>add</mat-icon> Lägg till delning av lön
                </button>
              </div>

            </div>
            <div class="col-lg-12" *ngIf="payoutSalarySharesToggleOpen">
              <div class="payment-part-body">
                <div *ngFor="let c of invoice.SalaryShares; let i = index" class="payment-part-row col-lg-12">

                  <div class="row" *ngIf="c.SalaryReciever.Id == null">
                    <h4 style="width: 100%; margin-left: 15px;">Mottagarens personnr/orgnr</h4>
                    <div class="col-lg-3 quick-add">
                      <input [disabled]="isInvoiceContentLocked()" matInput class="text-input amount search" [(ngModel)]="c.SearchAccountValue" (ngModelChange)="c.SearchAccountValue = $event;personalOrCompanyNumberValid($event, c);" (input)="SearchAccount(c.SearchAccountValue,c)" type="text" placeholder="ÅÅMMDDNNNN">
                      <mat-icon [hidden]="!c.SearchAccountValid || c.SearchAccountValue == null" class="check" matTooltipPosition="after">check</mat-icon>

                      <div *ngIf="c.SearchAccountValid && c.SalaryReciever.Id == null" style="height: 20px;">
                        <span class="fontsize80" style="font-style: italic;">Användaren finns inte registrerad</span>
                      </div>
                    </div>

                    <div *ngIf="c.SearchAccountValid && c.SalaryReciever.Id == null" class="col-lg-6 quick-add">
                      <button mat-flat-button color="accent" [disabled]="!canUpdateGeneral()" (click)="openAddUserAccountModal(c)" style="height:43px; width:250px; cursor:pointer;">
                        <mat-icon>add</mat-icon> Lägg till mottagare
                      </button>
                      <div class="fontsize80" style="height: 20px; font-style: italic; padding-top: 3px;">Mottagaren saknas i vårt register, klicka för att lägga till</div>
                    </div>

                    <div class="col-lg-3">
                      <button mat-raised-button color="primary" style="margin-top: 5px;" [disabled]="!canUpdatePayout() || hasSubInvoices" (click)="deleteShare(i)">Ta bort</button>
                    </div>
                  </div>

                  <div class="row" *ngIf="c.SalaryReciever.FirstName != null">
                    <div class="col-lg-3">
                      <div style="height: 20px; font-weight: bold;"><span>{{c?.SalaryReciever?.FirstName + ' ' + c?.SalaryReciever?.LastName}}</span></div>
                    </div>

                    <div class="col-lg-3">
                      <mat-form-field floatLabel="always" style="margin-right: 10px;">
  <mat-label>Ange typ</mat-label>
                        <mat-select [disabled]="!canUpdatePayout() || hasSubInvoices" [(ngModel)]="c.ShareType.Id" (ngModelChange)="shareTypeChanged($event,c)">
                          <mat-option *ngFor="let e of invoiceShareTypes" [value]="e.Id">
                            {{ e.Name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="col-lg-3">
                      <mat-form-field floatLabel="always" *ngIf="c.ShareType.Id == 2" style="margin-right: 10px;">
  <mat-label>Del av fakturabeloppet (SEK)</mat-label>
                        <input class="text-input" matInput [disabled]="!canUpdatePayout() || hasSubInvoices" type="number" [(ngModel)]="c.Salary" (ngModelChange)="c.Salary = $event">
                      </mat-form-field>

                      <mat-form-field floatLabel="always" *ngIf="c.ShareType.Id == 1" style="margin-right: 10px;">
  <mat-label>Andel (%)</mat-label>
                        <input class="text-input" matInput [disabled]="!canUpdatePayout() || hasSubInvoices" type="number" [(ngModel)]="c.Share" (ngModelChange)="c.Share = $event">
                      </mat-form-field>
                    </div>
                    <div class="col-lg-3">
                      <button mat-raised-button color="primary" style="margin-top: 5px;" [disabled]="!canUpdatePayout() || hasSubInvoices" (click)="deleteShare(i)">Ta bort</button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-card>
      </div>

      <div class="col-sm-12" style="margin-top:15px;">
        <mat-card class="col-sm-12 invoice-message-card">

          <mat-card-title class="invoice-message-title">
            Meddelande till SAMpoolen
          </mat-card-title>

          <div class="invoice-message-field-row">
            <mat-form-field floatLabel="always" color="accent" appearance="outline" class="col-sm-12 col-lg-10 invoice-message-field">
              <mat-label>Meddelande</mat-label>
              <textarea matInput [ngModel]="invoice?.Message" (ngModelChange)="invoice.Message = $event" rows="3" placeholder="Skriv meddelande här" id="message" name="message" md-select-on-focus></textarea>
            </mat-form-field>
            <button mat-stroked-button mat-raised-button class="col-sm-12 col-lg-2" *ngIf="(!canUpdateInvoiceDraft() && invoice.Id != 0) || invoice.Status.Name != 'Utkast'" [disabled]="messageSending || invoice.Message == undefined || invoice.Message == ''" (click)="sendMessage(invoice.Message)">Skicka</button>
          </div>

          <div *ngFor="let message of invoice.Messages">
            <span>
              <i>({{message.Created | swedishDate: 'yyyy-MM-dd'}})</i>&nbsp;<b>{{message.CreatedBy}}:</b><br />
              <span class="angular-with-newlines">{{message.Text}}</span>
            </span>
          </div>
        </mat-card>
      </div>

      <div class="col-lg-9">
      </div>

      <!--<mat-form-field floatLabel="always" *ngIf="!invoice.SubInvoice" class="col-3">
  <mat-label>Kampanjkod</mat-label>
      <input type="text" [(ngModel)]="DiscountCode" matInput disabled />
    </mat-form-field>-->

      <div class="col-lg-6" *ngIf="pensionSavingsTotalAmount > 0 || pensionSavingsPercent > 0" style="margin-bottom:20px;">
        <mat-form-field floatLabel="always" style="margin-right: 10px; width: 100%;">
          <mat-label>{{invoice.Currency.Name == 'SEK' ? 'Total tjänstepension inkl skatt för denna faktura' : 'Avsättning i % av fakturabeloppet'}}</mat-label>
          <input *ngIf="invoice.Currency.Name == 'SEK'" class="text-input" matInput disabled [(value)]="pensionSavingsTotalAmount">
          <input *ngIf="invoice.Currency.Name != 'SEK'" class="text-input" matInput disabled [(value)]="pensionSavingsPercent">
        </mat-form-field>
        <div *ngIf="invoice.Currency.Name == 'SEK'">Du har angett att du vill avsätta {{pensionSavingsTotalAmount}} {{invoice.Currency.Name}} (inkl skatt) till din tjänstepension. <span class="error-message" *ngIf="errorMessagePension != ''">{{errorMessagePension + '.'}}</span> Under punkt 4 kan du ändra för denna faktura.</div>
        <div *ngIf="invoice.Currency.Name != 'SEK'">Du har angett att du vill avsätta {{pensionSavingsPercent}} % av lönebaserande belopp till din tjänstepension. <span class="error-message" *ngIf="errorMessagePension != ''">{{errorMessagePension + '.'}}</span> Under punkt 4 kan du ändra för denna faktura.</div>
      </div>
      <div class="col-lg-8 offset-lg-4" style="margin-bottom:20px;">
        <div class="terms-links">
          <a class="accent" [href]="fileService.buildPublicDocumentUrl('AllmannaVillkorEgenanstalld.pdf')" target="_blank">Allmänna villkor för egenanställd</a> |
          <a class="accent" [href]="fileService.buildPublicDocumentUrl('AllmannaVillkorKund.pdf')" target="_blank">Allmänna villkor för kund</a> |
          <a class="accent" [href]="fileService.buildPublicDocumentUrl('Integritetspolicy.pdf')" target="_blank">Integritetspolicy</a>
        </div>

        <div style="text-align: right;">
          <mat-checkbox [disabled]="isInvoiceContentLocked()" label="Härmed godkänner jag"
                        *ngIf="invoice"
                        [(ngModel)]="invoice.termsAgreed">
            Härmed godkänner jag villkor och integritetspolicy
          </mat-checkbox>
        </div>
      </div>
      <div class="col-lg-8 invoice-actions-left">
        <button mat-flat-button color="primary" class="col-sm-6 col-lg-4" (click)="cancel()">Avbryt</button>
        <button *ngIf="!invoice.SubInvoice"
                style="margin-left: 5px;"
                mat-stroked-button
                [class.disabled]="isLoading || invoiceGroupSaving || !sendValidates(true) || !canUpdateInvoice()"
                [disabled]="isLoading || invoiceGroupSaving || !sendValidates(true) || !canUpdateInvoice()"
                (click)="handleSendClick(invoice)">
          Begär offert
        </button>
        <button mat-stroked-button class="preview-btn" style="margin-left: 5px;" (click)="openInvoicePreview()" [disabled]="!validPreview()">Förhandsgranska</button>
        <button mat-stroked-button class="preliminary-salary-button" style="margin-left: 5px;" (click)="openPreliminarySalaryDialog()" [disabled]="!hasPreliminarySalaryAmount() || invoiceHasBeenSent()">Preliminär löneberäkning</button>
      </div>
      <div class="col-sm-6 col-lg-4 buttonrow invoice-actions-right">
        <!--<button mat-stroked-button (click)="preview(invoice)" [disabled]="isLoading || !validPreview()">Sammanställning</button>-->
        <button mat-stroked-button *ngIf="invoice.Status.TechnicalName != 'Draft'" (click)="saveDraft(invoice)" [disabled]="isInvoiceContentLocked() || (isLoading || invoiceGroupSaving)">Spara</button>
        <button mat-stroked-button *ngIf="invoice.Status.TechnicalName == 'Draft'" (click)="saveDraft(invoice)" [disabled]="isLoading || invoiceGroupSaving || !canUpdateInvoiceDraft()">Spara utkast</button>
        <button *ngIf="!invoice.SubInvoice" mat-flat-button (click)="send(invoice)" [disabled]="isLoading || invoiceGroupSaving || !sendValidates() || !canUpdateInvoice()" color="accent">Skicka faktura</button>
      </div>
      <div class="col-lg-12 invoice-warning-row">
        <span *ngIf="!invoice.SubInvoice" class="invoice-warning-message" [innerHTML]="requiresPensionSavingsCompany() ? 'Du måste ange ett företag för din pensionsavsättning' : ErrorMessageSend"></span><br />
      </div>
    </div>
  </div>

  <ng-template #expressBankIdDialog>
    <div class="express-payout-dialog">
      <h2 mat-dialog-title>BankID-inloggning krävs</h2>
      <mat-dialog-content>
        <p>För att kunna välja alternativet Expressutbetalning krävs att du är inloggad med BankID.</p>
        <p>Du kommer nu att skickas till BankID-inloggningen och sedan tillbaka till din nystartade faktura. För din och vår säkerhet loggar vi IP-nummer på alla inloggningar.</p>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button type="button" mat-stroked-button [mat-dialog-close]="{ Confirmed: false }">Avbryt</button>
        <button type="button" mat-flat-button color="accent" [mat-dialog-close]="{ Confirmed: true }">Fortsätt till BankID</button>
      </mat-dialog-actions>
    </div>
  </ng-template>

  <ng-template #expressPayoutDialog>
    <div class="express-payout-dialog">
      <h2 mat-dialog-title>Expressutbetalning</h2>
      <mat-dialog-content>
        <p>För att få en djupare kunskap kring riskerna med expressutbetalning, vänligen kontakta oss för utförlig information.</p>
        <p>Viktigast att veta är att man eventuellt kan bli återbetalningsskyldig för de eventuella utgifter SAMpoolen haft för löneutbetalningen, om fakturan förblir obetald efter alla gängse påtryckningar.</p>
        <p>Om du redan är införstådd med riskerna kan du klicka dig vidare.</p>
        <p>Härmed intygar jag att jag är införstådd med riskerna kring expressutbetalning</p>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button type="button" mat-stroked-button [mat-dialog-close]="{ Confirmed: false }">Avbryt</button>
        <button type="button" mat-flat-button color="accent" [mat-dialog-close]="{ Confirmed: true }">Godkänn</button>
      </mat-dialog-actions>
    </div>
  </ng-template>

  <ng-template #vatInformationDialog>
    <div class="vat-information-dialog">
      <div class="vat-information-dialog-header">
        <h2 mat-dialog-title>Jag har framträtt som artist – varför kan jag inte välja 0 % moms?</h2>
        <button mat-icon-button mat-dialog-close aria-label="Stäng"><mat-icon>close</mat-icon></button>
      </div>
      <mat-dialog-content>
        <p>Artistframträdanden via SAMpoolen ska alltid faktureras med 25 % moms.</p>
        <p>För att ett artistframträdande ska få faktureras med 0 % moms måste de medverkande artisterna själva vara majoritetsägare i det fakturerande bolaget. Det villkoret är inte uppfyllt när du fakturerar genom SAMpoolen.</p>
        <h3>Min kund kräver momsfritt och vill inte betala moms</h3>
        <p>För en momsregistrerad företagskund med avdragsrätt utgör momsen normalt ingen kostnad. Den redovisas som ingående moms och kvittas mot utgående moms eller återbetalas av Skatteverket. Undantag kan förekomma om kunden saknar eller har begränsad avdragsrätt.</p>
        <h3>Jag har utfört arbete inom ett annat område som kan faktureras med 0 % moms</h3>
        <p>Även andra typer av uppdrag kan vara undantagna från moms. Styrelseuppdrag är ett exempel, men varje uppdrag måste bedömas utifrån sina förutsättningar. Beskriv uppdraget i meddelanderutan längst ner, så korrigerar vi momsen manuellt om villkoren är uppfyllda.</p>
        <p class="vat-information-dialog-source">
          Läs mer hos
          <a href="https://www.skatteverket.se/foretagochorganisationer/moms/saljavarorochtjanster/momssatspavarorochtjanster.4.58d555751259e4d66168000409.html" target="_blank" rel="noopener noreferrer">Skatteverket om momssatser och artistframträdanden</a>.
        </p>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-stroked-button mat-dialog-close>Stäng</button>
      </mat-dialog-actions>
    </div>
  </ng-template>

  <ng-template #preliminarySalaryDialog>
    <div class="preliminary-salary-dialog">
      <div class="preliminary-salary-dialog-header">
        <h2 mat-dialog-title>Preliminär löneberäkning</h2>
        <button mat-icon-button mat-dialog-close aria-label="Stäng"><mat-icon>close</mat-icon></button>
      </div>
      <mat-dialog-content>
        <div *ngIf="preliminarySalaryLoading" class="preliminary-salary-status">Beräknar preliminär löneutbetalning...</div>
        <div *ngIf="preliminarySalaryError" class="preliminary-salary-error">{{preliminarySalaryError}}</div>
        <div *ngIf="preliminarySalaryCalculation && !preliminarySalaryLoading" class="preliminary-salary-calculation">
          <div class="preliminary-salary-summary">
            <span>Preliminär utbetalning:</span>
            <span class="preliminary-salary-summary-amount">{{preliminarySalaryCalculation.totalPayout | number:'1.0-0'}} SEK</span>
            <small>
              {{preliminarySalaryCalculation.netSalary | number:'1.0-0'}} SEK nettolön
              <ng-container *ngIf="preliminarySalaryCalculation.netExpenses > 0">
                + {{preliminarySalaryCalculation.netExpenses | number:'1.0-0'}} SEK nettoersättningar
              </ng-container>
              <ng-container *ngIf="preliminarySalaryCalculation.wageGarnishment > 0">
                - {{preliminarySalaryCalculation.wageGarnishment | number:'1.0-0'}} SEK löneutmätning
              </ng-container>
            </small>
          </div>
          <div class="preliminary-salary-date">
            <div>Fakturans förfallodag: <strong>{{preliminarySalaryCalculation.dueDateText}}</strong></div>
            <div>Beräknad utbetalningsdag: <strong>{{preliminarySalaryCalculation.calculationDateText}}</strong></div>
            <p *ngIf="!preliminarySalaryCalculation.isExpressPayout">Utbetalningsdagen är beräknad till nästkommande vardag efter fakturans förfallodag.</p>
            <p *ngIf="preliminarySalaryCalculation.isExpressPayout">Eftersom du valt express är utbetalningsdagen beräknad till nästföljande vardag. Detta under förutsättning att din kontaktperson svarar på vår förfrågan att underlaget är korrekt.</p>
            <p *ngIf="preliminarySalaryCalculation.hasWageGarnishment">
              Löneutmätningen är preliminärt beräknad som om samtliga avdrag och nettoersättningar inte är utmätningsbara. Utbetalningsbeloppet kan ändras om någon nettoersättning visar sig vara utmätningsbar eller om utbetalningen sker senare, särskilt efter ett månadsskifte.
            </p>
          </div>
          <div class="preliminary-salary-row preliminary-salary-no-divider"><span>Fakturerat belopp, exkl moms</span><span>{{preliminarySalaryCalculation.invoiceAmount | number:'1.0-0'}} SEK</span></div>
          <div class="preliminary-salary-row preliminary-salary-no-divider" *ngIf="preliminarySalaryCalculation.serviceFee > 0"><span>Avgift till SAMpoolen ({{preliminarySalaryCalculation.serviceFeeRate | number:'1.0-2'}} %)</span><span>- {{preliminarySalaryCalculation.serviceFee}} SEK</span></div>
          <div class="preliminary-salary-row preliminary-salary-no-divider" *ngIf="preliminarySalaryCalculation.invoiceFee > 0"><span>Din fakturaavgift</span><span>- {{preliminarySalaryCalculation.invoiceFee | number:'1.0-0'}} SEK</span></div>
          <div class="preliminary-salary-row preliminary-salary-total"><span>Delsumma efter avgifter</span><span>{{preliminaryPayout | number:'1.0-0'}} SEK</span></div>
          <div class="preliminary-salary-row" *ngIf="preliminarySalaryCalculation.pensionInclTax > 0"><span>Pensionsavsättning ({{preliminarySalaryCalculation.pensionAmount | number:'1.0-0'}} SEK, plus {{preliminarySalaryCalculation.pensionTax | number:'1.0-0'}} SEK i skatt)</span><span>- {{preliminarySalaryCalculation.pensionInclTax | number:'1.0-0'}} SEK</span></div>
          <div class="preliminary-salary-row" *ngIf="preliminarySalaryCalculation.deductions > 0"><span>Privata utlägg</span><span>{{preliminarySalaryCalculation.deductions | number:'1.0-0'}} SEK</span></div>
          <div class="preliminary-salary-row" *ngIf="preliminarySalaryCalculation.allowances > 0"><span>Traktamenten</span><span>{{preliminarySalaryCalculation.allowances | number:'1.0-0'}} SEK</span></div>
          <div class="preliminary-salary-row" *ngIf="preliminarySalaryCalculation.mileage > 0"><span>Milersättning</span><span>{{preliminarySalaryCalculation.mileage | number:'1.0-0'}} SEK</span></div>
          <div class="preliminary-salary-row preliminary-salary-total"><span>Totalt lönegrundande belopp</span><span>{{preliminarySalaryCalculation.salaryBasis | number:'1.0-0'}} SEK</span></div>
          <div class="preliminary-salary-row preliminary-salary-no-divider"><span>Arbetsgivaravgift ({{preliminarySalaryCalculation.employerTaxRate | number:'1.0-2'}} %)</span><span>- {{preliminarySalaryCalculation.employerTaxAmount | number:'1.0-0'}} SEK</span></div>
          <div class="preliminary-salary-row preliminary-salary-emphasis preliminary-salary-no-divider"><span>Bruttolön (inkl semesterersättning 12 %)</span><strong>{{preliminarySalaryCalculation.grossSalary | number:'1.0-0'}} SEK</strong></div>
          <div class="preliminary-salary-row preliminary-salary-no-divider"><span>Preliminär skatt ({{preliminarySalaryCalculation.municipalityTaxRate | number:'1.0-2'}} %)</span><span>- {{preliminarySalaryCalculation.municipalityTaxAmount | number:'1.0-0'}} SEK</span></div>
          <div class="preliminary-salary-row preliminary-salary-emphasis preliminary-salary-no-divider"><span>Nettolön</span><strong>{{preliminarySalaryCalculation.netSalary | number:'1.0-0'}} SEK</strong></div>
          <div class="preliminary-salary-row" *ngIf="preliminarySalaryCalculation.wageGarnishment > 0"><span>Löneutmätning</span><span>- {{preliminarySalaryCalculation.wageGarnishment | number:'1.0-0'}} SEK</span></div>
          <div class="preliminary-salary-row preliminary-salary-emphasis preliminary-salary-no-divider" *ngIf="preliminarySalaryCalculation.wageGarnishment > 0"><span>Kvar att betalas ut till ditt konto</span><strong>{{preliminarySalaryCalculation.netSalaryPayout | number:'1.0-0'}} SEK</strong></div>
          <div class="preliminary-salary-row preliminary-salary-payout-part"><span>Nettolön som betalas ut till ditt konto</span><span>{{preliminarySalaryCalculation.netSalaryPayout | number:'1.0-0'}} SEK</span></div>
          <div class="preliminary-salary-row" *ngIf="preliminarySalaryCalculation.netExpenses > 0"><span>Nettoersättningar som betalas ut till ditt konto</span><span>{{preliminarySalaryCalculation.netExpenses | number:'1.0-0'}} SEK</span></div>
          <div class="preliminary-salary-row preliminary-salary-payout-total"><span>Total preliminär utbetalning</span><span>{{preliminarySalaryCalculation.totalPayout | number:'1.0-0'}} SEK</span></div>
          <p class="preliminary-salary-notice">
            Alla avdrag och ersättningar är preliminärt beräknade som godkända. Beloppen kan ändras om underlagen inte godkänns av Skatteverket.
          </p>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-stroked-button mat-dialog-close>Stäng</button>
      </mat-dialog-actions>
    </div>
  </ng-template>
